import {IDataDiscipline} from "../_interfaces/IDataDiscipline";

const data_disziplinen: IDataDiscipline[] = [
    {
        url: "/wiki/Besch%C3%BCtzer",
        name: "Beschützer",
        descr: "Beschützer verwandeln ihren Körper in lebende Waffen, verbessern ihre Fähigkeiten durch Willenskraft und streben nach einem einzigen, perfekten Angriff. Sie können selbstständig sein, versuchen aber, die Welt zu erfahren und über diese Erfahrungen nachzudenken, indem sie ihren Geist für tiefere Geheimnisse in ihrem Inneren öffnen.",
        mainAttributes: ['wah', 'str', 'wil'],
        karmaritual: "Der Adept kniet oder sitzt, sodass seine Haut in direktem Kontakt mit Erde oder Stein steht. Er erweitert seine Sinne und spürt die Welt um sich herum. Er spürt die Erde, das Feuer, das Wasser und das Holz um sich herum. Der Adept verengt seinen Fokus in den nächsten 30 Minuten auf einen einzigen Punkt, einen einzigen Moment. Wenn die Zeit vorbei ist, springt ein Splitter des Bodens in die Luft, und der Beschützer erhebt sich, schlägt zu und zerstört ihn mit einer einzigen fließenden Bewegung.",
        kunsthandwerk: ['Körpermalerei', "Runenschnitzen"],
        halbmagie: "Beschützer verwenden Halbmagie für das Wissen über die Elemente, verschiedene waffenlose Kampftechniken und die Frage, welche prominenten unbewaffneten Kämpfer den Kampfstil von jemandem geprägt haben. Sie setzen Halbmagie auch ein, um Erschöpfung oder Ablenkungen zu widerstehen oder ähnliche Ausdrucksformen von Willenskraft und Ausdauer zu zeigen.",
        TuF: {
            optionen: [
                {
                    f: 1,
                    t: 4,
                    talente: ["Artefaktgeschichte", "Aufmerksamkeit", "Etikette", "Feuerblut", "Gefahrensinn", "Holzhaut", "Kampfgebrüll", "Manövrieren", "Mystische Verfolgung", "Wildnisüberleben"]
                },
                {
                    f: 5,
                    t: 8,
                    talente: ["Astralsicht", "Beweisanalyse", "Eiserne Konstitution", "Heilendes Feuer", "Löwenherz", "Reinigende Kälte", "Schwachstelle Erkennen", "Stählerner Blick", "Starrsinn", "Wasserfallschlag"]
                },
                {
                    f: 9,
                    t: 12,
                    talente: ["Brennende Kraft", "Letzte Rettung", "Löwenmut", "Matrixsicht", "Rankenrüstung", "Schadensverteilung", "Schmerzen Widerstehen", "Tödlicher Schlag", "Unaufhaltsame Erholung", "Verteidigungshaltung"]
                },
                {
                    f: 13,
                    t: 15,
                    talente: ["Ätherwaffe", "Aurarüstung", "Eisiger Schlag", "Elementarwandeln", "Herausforderung der Besten", "Seelenschutz", "Vitaler Schutz", "Zweite Chance"]
                }
            ],
            1: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 0, s: 0},
                bew: 7,
                tot: 8,
                free: [],
                karma: "",
                talente: ["Fadenweben [Beschützerweben]", "Hieb Ausweichen", "Körperkontrolle", "Standhaftigkeit", "Waffenloser Kampf"]
            },
            2: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 0, s: 0},
                talente: ["Wohlüberlegter Angriff"]
            },
            3: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 0, s: 0},
                karma: "Der Adept darf 1 Karmapunkt für Erholungsproben ausgeben.",
                talente: ["Eiserner Wille"]
            },
            4: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 1, s: 0},
                talente: ['Durchdachter Konter']
            },
            5: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 1, s: 0},
                add: ["Elementare Haltung: Nachdem die Aktionen für die Runde angekündigt wurden, aber bevor sie ausgeführt werden, kann der Adept für 1 Punkt Überanstrengung Elementare Haltung verwenden. Er erhält einen Bonus von +2 zu seiner waffenlosen Angriffsprobe, seiner waffenlosen Schadensprobe, seiner Physischen Rüstung oder seiner Mystischen Rüstung. Der Adept kann in einer Runde, in der er diese Fähigkeit einsetzt, nur eine Angriffsprobe ablegen."],
                karma: "1 Karmapunkt für waffenlose Schadensproben",
                talente: ["Erdhaut"]
            },
            6: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 2, m: 1, s: 0},
                talente: ["Ätherhaut"]
            },
            7: {
                b: {ep: 1, mr: 0, ini: 0},
                v: {k: 2, m: 1, s: 0},
                talente: ["Hammerschlag"]
            },
            8: {
                b: {ep: 1, mr: 0, ini: 0},
                v: {k: 2, m: 2, s: 0},
                talente: ["Vernichtender Schlag"]
            },
            9: {
                b: {ep: 1, mr: 0, ini: 0},
                v: {k: 2, m: 2, s: 0},
                add: ["Strukturverstärkung: Der Adept führt ein achtstündiges Ritual durch, um seine Wahre Struktur zu verstärken und sie in seinen physischen Körper fließen zu lassen. Die Manifestation des Rituals hängt vom Adepten ab und davon, wie er seine Struktur verwendet. Wenn er sie in seine Hände einfließen lässt, können auf ihrer Oberfläche leuchtende Runen entstehen, wenn er einen Kampf erwartet oder sich in einen Kampf begibt, während ähnliche Runen am ganzen Körper vorhanden sein können, wenn der Adept seine Struktur defensiv einsetzt. Das Ritual jedes Adepten ist einzigartig und basiert auf seiner Ausbildung und persönlichen Philosophie. Einige reisen an einen Ort, an dem die Barriere zwischen den Welten schwach ist, an einen Ort von großer Macht, an einen Ort von persönlicher Bedeutung oder an einen Ort, der Kontemplation und Introspektion unterstützt. Das Ritual wird oft als letzter Schritt auf dem Weg zum Hüter durchgeführt, kann aber jederzeit durchgeführt werden. Nach dem Ritual erleidet der Adept 1 Punkt Blutmagieschaden und wählt eine der folgenden Wirkungen: +3 auf seine waffenlosen Schadensproben oder +3 auf seine Physische Rüstung. Der Adept kann dieses Ritual erneut durchführen, um seinen Bonus zu ändern oder ihn ganz zu entfernen."],
                karma: "1 Karmapunkt für jede aktive Verteidigungsprobe (z. B. Eiserner Wille, Hieb Ausweichen, Starrsinn usw.)",
                talente: ["Kritischer Treffer"]
            },
            10: {
                b: {ep: 1, mr: 1, ini: 0},
                v: {k: 3, m: 2, s: 0},
                talente: ["Unverzagte Tapferkeit"]
            },
            11: {
                b: {ep: 1, mr: 1, ini: 0},
                v: {k: 3, m: 2, s: 1},
                karma: "einmal pro Runde 1 Karmapunkt für eine waffenlose Angriffsprobe",
                talente: ["Astralangriff"]
            },
            12: {
                b: {ep: 2, mr: 1, ini: 0},
                v: {k: 3, m: 3, s: 1},
                talente: ["Geduldige Widerstandskraft"]
            },
            13: {
                b: {ep: 2, mr: 1, ini: 1},
                add: ["Strukturmanifestation: Als Einfache Aktion für 4 Punkte Überanstrengung manifestiert und verstärkt der Adept seine Struktur in seinem Körper vollständig und verstärkt die sichtbaren Effekte der Fähigkeit Strukturverstärkung. Alle Angriffe, die mit Körperkontrolle durchgeführt werden, erhalten eines der folgenden Merkmale: Erde, Erde – Metall, Feuer, Holz oder Wasser – Kälte. Zusätzlich erhält der Adept einen Bonus von +3 auf waffenlose Angriffsproben, waffenlose Schadensproben, seine Physische Rüstung und seine Mystische Rüstung (dies addiert sich nicht zum Bonus aus Strukturverstärkung)."],
                v: {k: 4, m: 3, s: 1},
                talente: ["Steinhaut"]
            },
            14: {
                b: {ep: 2, mr: 2, ini: 1},
                v: {k: 4, m: 4, s: 1},
                talente: ["Üble Wunde"]
            },
            15: {
                b: {ep: 3, mr: 2, ini: 1},
                v: {k: 4, m: 4, s: 2},
                talente: ["Willen Brechen"]
            }
        }
    },
    {
        url: "/wiki/Bootsmann",
        name: "Bootsmann",
        descr: "Bootsmänner dienen an Bord unzähliger Flussschiffe auf dem Schlangenfluss. Nicht jedes Besatzungsmitglied ist ein Bootsmann, aber Bootsmänner sind die besten Offiziere und Kapitäne auf dem Fluss. Ein Bootsmann muss den Fluss, seine Mannschaft und sein Schiff kennen; aber viele Bootsmänner haben den heftigen Wunsch, auch über alles andere ein wenig Bescheid zu wissen.",

        mainAttributes: ["cha", "ges", "wil"],
        karmaritual: "Der Bootsmann sitzt mehrere Minuten lang allein in stiller Meditation, vorzugsweise in der Nähe eines Flusses oder eines anderen Gewässers, und stellt sich vor, wie sein Flussschiff zu Beginn einer langen Reise durch die Strömung fährt. Der Adept stellt sich eine Reise vor, von der er hofft, sie eines Tages unternehmen zu können. Er stellt sich Szenen dieser Reise vor, einschließlich der Risiken und Gefahren und wie seine Ausbildung und seine Fähigkeiten dazu beitragen könnten, dass die Reise sicher verläuft. Das Ritual ist beendet, wenn die imaginierte Reise eine halbe Stunde später sicher endet.",
        kunsthandwerk: ["Holzschnitzen", "Runenschnitzen"],
        halbmagie: "Der Bootsmann verwendet Halbmagie für die Kenntnis von Flussschiffdesigns, zur Erkennung verschiedener Typen von Flussschiffen, allgemein bekannten Flusshandelsrouten und zum Anheuern von Besatzungen. Er kann damit auch die Wartung, die Reparatur und den Bau von Flussschiffen (nicht aber von Feuermaschinen) abdecken.\nAnmerkung: Bootsmänner in Barsaive sind in erster Linie T’skrang. Sie haben keine Verbindung zur Luft wie die Luftsegler, sondern zum Wasser, insbesondere zum strömenden Wasser des Flusssystems. Segler bewegen sich zwischen beiden Welten, überqueren die Meere und Flüsse, sind aber auf den Wind angewiesen, um ihre Reise zu beschleunigen. Luftsegler, Bootsmann und Segler werden hinsichtlich der Erfüllung von Anforderungen als dieselbe Disziplin behandelt. Luftweben, Flussweben und Meeresweben werden hinsichtlich der Erfüllung von Anforderungen als dasselbe Talent behandelt.",
        TuF: {
            optionen: [
                {
                    f: 1,
                    t: 4,
                    talente: ["Akrobatische Verteidigung", "Erster Eindruck", "Feilschen", "Fluss Lesen", "Fremdsprachen", "Manövrieren", "Verspotten", "Waffenloser Kampf", "Weitsprung", "Wurfwaffen"]
                },
                {
                    f: 5,
                    t: 8,
                    talente: ["Eleganter Abgang", "Etikette", "Führung", "Gegenstand Verbergen", "Nachtreten", "Schlachtruf", "Starrsinn", "Überraschungsschlag", "Wortgeplänkel", "Zweitwaffe"]
                },
                {
                    f: 9,
                    t: 12,
                    talente: ["Adlerauge", "Astralsicht", "Beeindrucken", "Luftgleiten", "Reinigende Kälte", "Schadensverteilung", "Schmetterschlag", "Schwachstelle Erkennen", "Unaufhaltsame Erholung", "Verteidigungshaltung"]
                },
                {
                    f: 13,
                    t: 15,
                    talente: ["Entwaffnendes Lächeln", "Fließende Bewegung", "Herausforderung der Besten", "Kritischer Treffer", "Letzte Rettung", "Seelenschutz", "Untergraben", "Zweite Chance"]
                }
            ],
            1: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 0, s: 0},
                bew: 5,
                tot: 6,
                free: ["Boot Steuern", "Segeln"],
                karma: "einmal pro Runde 1 Karmapunkt für eine beliebige Aktion, während er sich an Bord eines Flussschiffes befindet.",
                talente: ["Fadenweben [Flussweben]", "Hieb Ausweichen", "Klettern", "Nahkampfwaffen", "Schwimmen"]
            },
            2: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 0, s: 0},
                talente: ["Aufmerksamkeit"]
            },
            3: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 0, s: 0},
                karma: "1 Karmapunkt für Initiativeproben.",
                talente: ["Empathische Wahrnehmung"]
            },
            4: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 0, s: 1},
                talente: ["Standhaftigkeit"]
            },
            5: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 0, s: 1},
                add: ["Zusammenarbeiten: Einmal pro Runde darf der Adept für 1 Punkt Überanstrengung einem Verbündeten als Einfache Aktion einen Bonus von +2 auf eine Probe für das Erreichen eines gemeinsamen Ziels geben. Der Spieler sollte beschreiben, wie der Adept seinem Verbündeten hilft."],
                karma: "1 Karmapunkt für Interaktionsproben",
                talente: ["Herzliches Lachen"]
            },
            6: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 2, m: 0, s: 1},
                talente: ["Entwaffnen"]
            },
            7: {
                b: {ep: 1, mr: 0, ini: 0},
                v: {k: 2, m: 0, s: 1},
                talente: ["Andere Inspirieren"]
            },
            8: {
                b: {ep: 1, mr: 0, ini: 0},
                v: {k: 3, m: 0, s: 1},
                talente: ["Löwenherz"]
            },
            9: {
                b: {ep: 1, mr: 0, ini: 0},
                v: {k: 3, m: 0, s: 1},
                add: ["Angriffe Koordinieren: Jegliche Bedrängt-Mali, die vom Adepten verursacht werden, während er mit seinen Verbündeten zusammenarbeitet, werden um 1 erhöht. Dies gilt nicht für Bedrängt- Mali, die von Zaubern verursacht werden."],
                karma: "Der Adept kann einen Karmapunkt für Erholungsproben ausgeben.",
                talente: ["Bleibender Eindruck"]
            },
            10: {
                b: {ep: 1, mr: 0, ini: 1},
                v: {k: 3, m: 0, s: 2},
                talente: ["Gedankenkette"]
            },
            11: {
                b: {ep: 1, mr: 0, ini: 1},
                v: {k: 3, m: 1, s: 2},
                karma: "Der Adept kann einen Karmapunkt pro Runde für eine Probe ausgeben, während er sich neben einem Verbündeten befindet.",
                talente: ["Löwenmut"]
            },
            12: {
                b: {ep: 2, mr: 0, ini: 1},
                v: {k: 4, m: 1, s: 2},
                talente: ["Ansporn"]
            },
            13: {
                b: {ep: 2, mr: 1, ini: 1},
                v: {k: 4, m: 1, s: 3},
                add: ["Geschwindigkeit des Flusses: Der Adept erleidet 4 Punkte Blutmagieschaden und legt eine Flussweben-(6)-Probe ab. Jeder Erfolg erhöht die Reisegeschwindigkeit seiner Gruppe um 10%. Diese Fähigkeit kann Fahrzeuge von maximal der Größe einer Galeere beeinflussen oder eine Gruppe von nicht mehr als 50 Personen, die zu Fuß gehen oder beritten sind. Im Kampf wird stattdessen die Bewegungsrate der betroffenen Fahrzeuge/Personen um 4 erhöht. Diese Fähigkeit wirkt für einen ganzen Tag, danach kann der Blutmagieschaden geheilt werden."],
                talente: ["Zweiter Angriff"]
            },
            14: {
                b: {ep: 2, mr: 1, ini: 2},
                v: {k: 5, m: 1, s: 3},
                talente: ["Lied der Schlachten"]
            },
            15: {
                b: {ep: 3, mr: 1, ini: 2},
                v: {k: 5, m: 2, s: 3},
                talente: ["Koordinierter Angriff"]
            }
        }
    },
    {
        url: "/wiki/Dieb",
        name: "Dieb",
        descr: "Diebe lernen schon früh in ihrem Leben, zu stehlen und sich nur auf sich selbst zu verlassen. Sie ziehen Kraft aus ihrem Selbstvertrauen und dem Wissen, dass sie nur von sich selbst abhängen. Die vielen Gerüchte über Diebesgilden lassen vermuten, dass solche Gruppen tatsächlich existieren, aber Beweise oder Gegenbeweise ihrer Existenz müssen erst noch erbracht werden",
        mainAttributes: ["cha", "ges", "wah"],
        karmaritual: "Der Dieb sitzt allein an einem dunklen Ort und konzentriert sich eine halbe Stunde lang auf das Wissen, dass er allein auf der Welt ist und sich, zuerst und zuvorderst, nur auf sich selbst verlassen kann. Mit diesem Gefühl im Herzen macht er sich dann auf, um eines seiner Disziplintalente einzusetzen. Das Ritual endet, sobald der Dieb das Talent erfolgreich einsetzt.",
        kunsthandwerk: ["Poesie", "Schauspielern"],
        halbmagie: "Diebe können Halbmagie einsetzen, um Sicherheitsmaßnahmen zu bauen oder zu umgehen, die Diebstähle verhindern sollen, und um verschiedene Arten von Schließmechanismen zu erkennen.",
        TuF: {
            optionen: [
                {
                    f: 1,
                    t: 4,
                    talente: ["Erster Eindruck", "Hieb Ausweichen", "Klettern", "Nahkampfwaffen", "Projektilwaffen", "Sprint", "Überraschungsschlag", "Verspotten", "Weitsprung", "Wurfwaffen"]
                },
                {
                    f: 5,
                    t: 8,
                    talente: ["Eleganter Abgang", "Klingen Jonglieren", "Magische Maske", "Mystische Verfolgung", "Projektil Rufen", "Schwachstelle Erkennen", "Stimmen Imitieren", "Totstellen", "Untrüglicher Blick", "Zweitwaffe"]
                },
                {
                    f: 9,
                    t: 12,
                    talente: ["Akrobatische Verteidigung", "Astralsicht", "Echolot", "Fluchtplan", "Kampfsinn", "Kreisender Spion", "Perfekte Konzentration", "Starrsinn", "Tigersprung", "Windkissen"]
                },
                {
                    f: 13,
                    t: 15,
                    talente: ["Astralangriff", "Entwaffnendes Lächeln", "Fließende Bewegung", "Geistwanden", "Kritischer Treffer", "Verteidigungshaltung", "Wie Eine Streunende Katze", "Zweite Chance"]
                }
            ],
            1: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 0, s: 0},
                bew: 5,
                tot: 6,
                free: ["Gefahrensinn"],
                karma: "1 Karmapunkt für eine beliebige auf Charisma basierende Probe, mit der er versucht, ein Ziel zu täuschen.",
                talente: ["Aufmerksamkeit", "Fadenweben [Diebweben]", "Heimlicher Schritt", "Schloss Knacken", "Taschendiebstahl"]
            },
            2: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 0, s: 0},
                talente: ["Fallen Entschärfen"]
            },
            3: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 0, s: 0},
                karma: "1 Karmapunkt für Initiativeproben",
                talente: ["Feilschen"]
            },
            4: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 0, s: 1},
                talente: ["Gegenstand Verbergen"]
            },

            5: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 0, s: 1},
                add: ["Schattenmantel: Für 2 Punkte Überanstrengung wird der Mindestwurf für alle Proben, um den Adepten zu entdecken, für eine Anzahl von Minuten gleich dem Rang des Adepten in Diebweben um +2 erhöht. Dies ist für den Adepten eine Einfache Aktion."],
                karma: "1 Karmapunkt für Angriffsproben gegen einen Gegner, der Überrascht ist oder den er aus dem Toten Winkel angreift.",
                talente: ["Wortgeplänkel"]
            },
            6: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 2, m: 0, s: 1},
                talente: ["Schuld Abwälzen"]
            },
            7: {
                b: {ep: 0, mr: 0, ini: 1},
                v: {k: 2, m: 0, s: 1},
                talente: ["Flinke Hand"]
            },
            8: {
                b: {ep: 0, mr: 0, ini: 1},
                v: {k: 3, m: 0, s: 1},
                talente: ["Illusionsverstärkung"]
            },

            9: {
                b: {ep: 0, mr: 0, ini: 1},
                v: {k: 3, m: 0, s: 1},
                add: ["Schattensicht: Der Adept erleidet keine Mali aufgrund von schlechter Beleuchtung oder Dunkelheit mehr. Dazu gehören auch Zauber und andere Wirkungen, die diese Mali verursachen, wie zum Beispiel Ätherische Finsternis. Zusätzlich gewährt ihm sein Schattenmantel eine größere Einsicht in die Dunkelheit. Wenn der Schattenmantel aktiv ist, erhält der Adept einen Bonus von +3 auf seine Aufmerksamkeit, wenn normalerweise Dunkelheitsmali für ihn gelten würden. Diese Fähigkeit negiert keine Mali durch Blindheit."],
                karma: "Der Adept kann einen Karmapunkt für Erholungsproben ausgeben.", talente: ["Machtmaskierung"]
            },
            10: {
                b: {ep: 1, mr: 0, ini: 1},
                v: {k: 3, m: 0, s: 2},
                talente: ["Astraltasche"]
            },
            11: {
                b: {ep: 1, mr: 0, ini: 1},
                v: {k: 3, m: 1, s: 2},
                karma: "Der Adept kann einen Karmapunkt für Schadensproben gegen Ziele ausgeben, die unter einem Malus auf ihre Körperliche Verteidigung leiden.",
                talente: ["Chamäleon"]
            },
            12: {
                b: {ep: 1, mr: 0, ini: 2},
                v: {k: 4, m: 1, s: 2},
                talente: ["Täuschende Klinge"]
            },
            13: {
                b: {ep: 1, mr: 1, ini: 2},
                v: {k: 4, m: 1, s: 3},
                add: ["Eins mit dem Schatten: Der Schattenmantel des Adepten erlaubt eine beispiellose Heimlichkeit. Der Adept erleidet 4 Punkte Überanstrengung und legt eine Diebweben-(6)-Probe ab. Gelingt die Probe, verschmilzt er eine Stunde lang mit seinem Schattenmantel und wird dadurch zu einer zweidimensionalen Silhouette, die mit Leichtigkeit durch alle Spalten schlüpfen kann, durch die Licht scheinen könnte. Jeder Erfolg bei der Probe verleiht dem Adepten einen Bonus von jeweils +2 auf seine Körperliche und Mystische Verteidigung sowie auf jede Aktionsprobe, um nicht bemerkt zu werden. In dieser Gestalt kann der Adept mit nichts Körperlichem interagieren. Talente, die ihre eigenen Werkzeuge bieten (z. B. Schloss Knacken), können nach Maßgabe des Spielleiters eingesetzt werden. Der Adept kann die Wirkung dieser Fähigkeit jederzeit beenden."],
                talente: ["Unmögliches Versteck"]
            },
            14: {
                b: {ep: 2, mr: 1, ini: 2},
                v: {k: 5, m: 1, s: 3},
                talente: ["Talentdiebstahl"]
            },
            15: {
                b: {ep: 2, mr: 1, ini: 3},
                v: {k: 5, m: 2, s: 3},
                talente: ["Traumdieb"]
            }
        }
    },
    {
        url: "/wiki/Krieger",
        name: "Krieger",
        descr: "Krieger sind Kämpfer und Soldaten, die darin geübt sind, mithilfe von Magie ihre Kampfkraft zu verstärken. Sie tun sich oft mit anderen Kriegern zusammen und führen Leben in unabhängiger Zurückgezogenheit – ähnlich wie Mönchsorden.",
        mainAttributes: ["ges", "str", "zae"],
        karmaritual: "Der Krieger sitzt im Schneidersitz und hält eine Waffe über seinen Knien. Nach einigen Minuten Meditation levitiert er, als ob er das Talent Lufttanz einsetzen würde. Durch den rituellen Einsatz dieses Talents erleidet er keine Überanstrengung. Dann führt der Krieger eine Abfolge von vier Übungen durch: die Erdverteidigung, die Wasserverteidigung, den Feuerangriff und den Luftangriff. Das Ritual endet, sobald der Krieger die letzte Bewegung des Luftangriffs vollendet.",
        kunsthandwerk: ["Bildhauerei", "Runenschnitzen"],
        halbmagie: "Krieger können Halbmagie einsetzen, um Waffen und Rüstungen zu pflegen oder zu reparieren, für Wissen über militärische Taktiken und Strategien (zum Beispiel über die sicherste Annäherung an ein Ziel, wenn man eine Schlacht plant) und um sich an Ereignisse in Barsaives Militärgeschichte zu erinnern. Sie verwenden Halbmagie außerdem, um Kriegerorden, berühmte Krieger der Vergangenheit und altertümliche Waffen und Rüstungen zu erkennen.",
        TuF: {
            optionen: [
                {
                    f: 1,
                    t: 4,
                    talente: ["Ablenken", "Akrobatische Verteidigung", "Feuerblut", "Gefahrensinn", "Kampfsinn", "Manövrieren", "Projektilwaffen", "Schildschlag", "Taktik", "Waffenloser Kampf"]
                },
                {
                    f: 5,
                    t: 8,
                    talente: ["Entwaffnen", "Etikette", "Führung", "Letzte Rettung", "Löwenherz", "Nachtreten", "Schwachstelle Erkennen", "Schwungvoller Angriff", "Stählerner Blick", "Zweitwaffe"]
                },
                {
                    f: 9,
                    t: 12,
                    talente: ["Ansporn", "Brennende Kraft", "Eiserne Konstitution", "Eiserner Wille", "Kritischer Treffer", "Löwenmut", "Schmerzen Widerstehen", "Sturmschild", "Tödlicher Schlag", "Verteidigungshaltung"]
                },
                {
                    f: 13,
                    t: 15,
                    talente: ["Astralangriff", "Ätherwaffe", "Fließende Bewegung", "Herausforderung der Besten", "Seelenschutz", "Üble Wunde", "Vitaler Schutz", "Zweite Chance"]
                }
            ],
            1: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 0, s: 0},
                bew: 7,
                tot: 8,
                talente: ["Fadenweben [Kriegsweben]", "Hieb Ausweichen", "Holzhaut", "Nahkampfwaffen", "Tigersprung"],
                free: [],
                karma: ""
            },
            2: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 0, s: 0},
                talente: ["Standhaftigkeit"]
            },
            3: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 0, s: 0},
                karma: "1 Karmapunkt für Erholungsproben",
                talente: ["Lufttanz"]
            },
            4: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 1, s: 0},
                talente: ["Wasserfallschlag"]
            },
            5: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 1, s: 0},
                add: ["Kampfriten: Der Adept meditiert 30 Minuten lang und wählt ein Talent aus. Im Laufe der nächsten 24 Stunden darf er bei jeder Begegnung als Einfache Aktion 1 Karmapunkt ausgeben, um die Überanstrengungskosten des Talents pro Runde für den Rest der Begegnung um 1 zu senken. Er darf pro Begegnung nur 1 Karmapunkt für diese Wirkung ausgeben, darf diese Fähigkeit aber in jeder Begegnung an diesem Tag verwenden."],
                karma: "1 Karmapunkt für Schadensproben im Nahkampf.",
                talente: ["Erdhaut"]
            },
            6: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 2, m: 1, s: 0},
                talente: ["Ätherhaut"]
            },
            7: {
                b: {ep: 1, mr: 0, ini: 0},
                v: {k: 2, m: 1, s: 0},
                talente: ["Hammerschlag"]
            },
            8: {
                b: {ep: 1, mr: 0, ini: 0},
                v: {k: 3, m: 1, s: 0},
                talente: ["Zweiter Angriff"]
            },
            9: {
                b: {ep: 1, mr: 0, ini: 0},
                v: {k: 3, m: 1, s: 0},
                add: ["Schlachtengespür: Wenn der Adept die Fähigkeit Kampfriten (siehe Fünfter Kreis) einsetzt, kann er 2 Punkte Blutmagieschaden erleiden, um 24 Stunden lang zu verhindern, aus dem Toten Winkel angegriffen, Bedrängt (gilt nur für die erste Bedrängt-Ursache in einer Runde) oder Überrascht zu werden. Wenn die Wirkung endet, kann er den Blutmagieschaden heilen."],
                karma: "Der Adept kann einen Karmapunkt pro Runde für jede Probe ausgeben, während er sich neben einem Verbündeten befindet.",
                talente: ["Unaufhaltsame Erholung"]
            },

            10: {
                b: {ep: 1, mr: 0, ini: 1},
                v: {k: 3, m: 2, s: 0},
                talente: ["Unverzagte Tapferkeit"]
            },
            11: {
                b: {ep: 1, mr: 0, ini: 1},
                v: {k: 3, m: 2, s: 1},
                karma: "Der Adept kann einen Karmapunkt für eine Angriffsprobe gegen einen Gegner ausgeben, der ihn seit dem Beginn der vorherigen Runde angegriffen hat.",
                talente: ["Eisiger Schlag"]
            },
            12: {
                b: {ep: 2, mr: 0, ini: 1},
                v: {k: 4, m: 2, s: 1},
                talente: ["Rankenrüstung"]
            },
            13: {
                b: {ep: 2, mr: 1, ini: 1},
                v: {k: 4, m: 3, s: 1},
                add: ["Krieger der Elemente: Wenn ein Krieger auf einem Schlachtfeld steht, ist er niemals allein. Die Elemente stehen an seiner Seite. Der Adept kann die Elemente manipulieren, um seine Gegner aus dem Gleichgewicht zu bringen, zum Beispiel durch Windstöße, Erdbewegungen, umschlingendes Unterholz, drückende Hitze, eisbedeckte Oberflächen usw. Unabhängig von der Art der elementaren Manifestation gelten alle Gegner, die sich im Nahkampf mit dem Adepten befinden, als Bedrängt.",],
                talente: ["Aurarüstung"]
            },
            14: {
                b: {ep: 2, mr: 1, ini: 2},
                v: {k: 5, m: 3, s: 1},
                talente: ["Steinhaut"]
            },
            15: {
                b: {ep: 3, mr: 1, ini: 2},
                v: {k: 5, m: 3, s: 2},
                talente: ["Mehrfacher Schlag"]
            }
        }
    },
    {
        url: "/wiki/Kundschafter",
        name: "Kundschafter",
        descr: "Kundschafter sind die Vorhut, die Fährtensucher und die mutigen Waldläufer, die dorthin gehen, wohin andere nicht gehen können. Sie sind Meister darin, eins mit ihrer Umgebung zu werden – ob dies nun ein Urwald ist oder das Herz der Stadt.",
        mainAttributes: ["ges", "wah"],
        karmaritual: "Zu Beginn seines Karmarituals lässt sich der Kundschafter von seinen Gefährten etwa zehn Minuten lang mit verbundenen Augen vom Ausgangspunkt wegführen. Dann meditiert er für zehn Minuten, während er sich den Weg zurück zum Ausgangspunkt vorstellt. Dann läuft er – immer noch mit verbundenen Augen – zum Ausgangspunkt zurück. Mit dem Entfernen der Augenbinde ist das halbstündige Ritual vollendet.",
        kunsthandwerk: ["Holzschnitzen", "Runenschnitzen"],
        halbmagie: "Ein Kundschafter kann Halbmagie einsetzen, um die Spuren verschiedener Tierarten und Namensgeber in der Wildnis und in städtischer Umgebung zu erkennen, außerdem für Wissen über Pflanzen und Kreaturen, die in einer Region heimisch sind, und sogar für allgemeine Informationen über die verschiedenen Kulturen in Barsaive.",
        TuF: {
            optionen: [
                {
                    f: 1,
                    t: 4,
                    talente: ["Fallen Entschärfen", "Fremdsprachen", "Hieb Ausweichen", "Kampfsinn", "Lesen/Schreiben", "Nahkampfwaffen", "Projektilwaffen", "Schloss Knacken", "Tieranalyse", "Weitsprung"]
                },
                {
                    f: 5,
                    t: 8,
                    talente: ["Gegenstand Verbergen", "Geisterreittier", "Magische Maske", "Schwachstelle Erkennen", "Sprint", "Tierfreundschaft", "Tierische Sinne", "Tigersprung", "Überraschungsschlag", "Untrüglicher Blick"]
                },
                {
                    f: 9,
                    t: 12,
                    talente: ["Abrichten", "Eiserne Konstitution", "Etikette", "Holzhaut", "Kritischer Treffer", "Letzte Rettung", "Mentale Tierkontrolle", "Pflanzensprache", "Tiersprache", "Unaufhaltsame Erholung"]
                },
                {
                    f: 13,
                    t: 15,
                    talente: ["Astralangriff", "Eidetisches Gedächtnis", "Geistwandeln", "Matrixsicht", "Seelenschutz", "Zweite Chance", "Zweiter Angriff", "Zweiter Schuss"]
                }
            ],
            1: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 0, s: 0},
                karma: "1 Karmapunkt für Proben, um etwas zu finden",
                bew: 5,
                tot: 6,
                free: ["Navigation"],
                talente: ["Aufmerksamkeit", "Fadenweben [Kundschafterweben]", "Klettern", "Spurenlesen", "Wildnisüberleben"]
            },
            2: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 0, s: 0},
                talente: ["Heimlicher Schritt"]
            },
            3: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 0, s: 0},
                karma: "1 Karmapunkt für Initiativeproben",
                talente: ["Mystische Verfolgung"]
            },
            4: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 1, s: 0},
                talente: ["Gefahrensinn"]
            },
            5: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 1, s: 0},
                add: ["Geschärfte Sinne: Für 1 Punkt Überanstrengung schärft der Adept mit einer Einfachen Aktion einen seiner natürlichen Sinne und erhält für 1 Runde einen Bonus von +2 auf Wahrnehmungsproben mit diesem Sinn. Wenn dieser Sinn nicht behindert wird, kann der Adept Mali für Blindheit ignorieren, indem er seinen geschärften Sinn als primären Sinn verwendet."],
                karma: "1 Karmapunkt für Erholungsproben",
                talente: ["Beweisanalyse"]
            },
            6: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 2, m: 1, s: 0},
                talente: ["Astralsicht"]
            },
            7: {
                b: {ep: 0, mr: 0, ini: 1},
                v: {k: 2, m: 1, s: 0},
                talente: ["Sicherer Pfad"]
            },
            8: {
                b: {ep: 0, mr: 0, ini: 1},
                v: {k: 3, m: 1, s: 0},
                talente: ["Kreisender Spion"]
            },
            9: {
                b: {ep: 0, mr: 0, ini: 1},
                v: {k: 3, m: 1, s: 0},
                add: ["Überirdische Aufmerksamkeit: Der Adept führt ein achtstündiges Ritual durch, um seine Sinne auf ein übernatürliches Niveau zu heben. Das Ritual ist bei jedem Adepten unterschiedlich und für gewöhnlich von den Unterweisungen, die der Adept erhalten hat, und seiner persönlichen Philosophie geprägt. Einige Adepten bilden eine tiefe Verbindung zur Natur aus und verlieren dabei ein Stück ihrer selbst, während andere mit dem – tatsächlichen oder metaphorischen – Geist einer Stadt kommunizieren. Das Ritual wird häufig als letzter Schritt durchgeführt, um ein Hüter zu werden, muss aber nicht zwingend zu dieser Zeit durchgeführt werden. Nach dem Ritual erleidet der Adept 1 Punkt Blutmagieschaden und addiert permanent +3 zu seinem Wahrnehmungswert."],
                karma: "Der Adept kann einen Karmapunkt für jede Probe ausgeben, mit der er der Entdeckung entgehen will.",
                talente: ["Adlerauge"]
            },
            10: {
                b: {ep: 1, mr: 0, ini: 1},
                v: {k: 3, m: 2, s: 0},
                talente: ["Chamäleon"]
            },
            11: {
                b: {ep: 1, mr: 0, ini: 1},
                v: {k: 3, m: 2, s: 1},
                karma: "Der Adept kann einen Karmapunkt auf Angriffsproben gegen Gegner ausgeben, die ihn in dieser Begegnung noch nicht angegriffen haben.",
                talente: ["Echolot"]
            },
            12: {
                b: {ep: 1, mr: 0, ini: 2},
                v: {k: 4, m: 2, s: 1},
                talente: ["Gestalt des Bluthundes"]
            },
            13: {
                b: {ep: 1, mr: 1, ini: 2},
                v: {k: 4, m: 3, s: 1},
                add: ["Eins mit der Welt: Der Adept kann sich in einen natürlichen Teil seiner Umgebung verwandeln. Er erleidet 3 Punkte Blutmagieschaden und legt eine Kundschafterweben-Proben gegen seine Mystische Verteidigung ab. Das Aussehen des Adepten, sein Akzent, sein Gebaren und so weiter passen sich an seine Umgebung an. In Wildnisgegenden verändert sich der Adept so, dass er in die Landschaft passt, während er in bevölkerten Gebieten so aussieht und sich so benimmt wie ein Einheimischer. Pro Erfolg bei der Kundschafterweben-Probe erhält der Adept einen Bonus von +2 auf alle Proben, um unbemerkt zu bleiben, sich einzufügen oder auf andere Weise so zu erscheinen, als ob er hierhergehört. Solange er nichts Ungewöhnliches tut oder aktiv die Aufmerksamkeit auf sich lenkt, sollten Proben, um ihn zu bemerken, nur erlaubt werden, wenn diejenige Person aktiv nach ihm sucht. Während die Fähigkeit aktiv ist, verleiht jeder Erfolg bei der Kundschafterweben-Probe dem Adepten außerdem einen Bonus von +2, um zu bemerken, dass etwas nicht passt oder verkehrt ist. Der Einsatz dieser Fähigkeit erzielt immer mindestens einen Erfolg und hält an, bis der Adept die Fähigkeit deaktiviert, worauf er dann den Blutmagieschaden heilen kann.",],
                talente: ["Wie Eine Streunende Katze"]
            },
            14: {
                b: {ep: 2, mr: 1, ini: 2},
                v: {k: 5, m: 3, s: 1},
                talente: ["Elementarwandeln"]
            },
            15: {
                b: {ep: 3, mr: 1, ini: 2},
                v: {k: 5, m: 3, s: 2},
                talente: ["Weltenpuls"]
            }
        }
    },
    {
        url: "/wiki/Luftpirat",
        name: "Luftpirat",
        descr: "Luftpiraten sind skrupellose Räuber und eine starke Macht in Barsaive. Ihre Luftschiffe streifen durch die ganze Provinz und überfallen sowohl Handelskarawanen als auch kleinere Städte und Dörfer. Luftpiraten sind stolz und gegenüber anderen Luftpiraten sehr loyal – es sei denn, dieser Luftpirat gehört zu einem feindlichen Clan oder Thing.",
        mainAttributes: ["cha", "ges", "str"],
        karmaritual: "Der Luftpirat verbringt mehrere Minuten in stiller Meditation unter offenem Himmel. Dann beginnt er, mit einer Waffe auf seinen Schild zu schlagen, langsam zuerst. Das Schlagen beschleunigt sich, bis der Luftpirat in einem wilden Stakkato auf seinen Schild hämmert. Kurz  bevor das Ritual endet, hört der Luftpirat auf und meditiert wieder, während sein Schild noch von dem wilden Gehämmere widerhallt. Das Karmaritual endet, sobald die Echos des letzten Schlages verklingen.",
        kunsthandwerk: ["Holzschnitzen", "Malen"],
        halbmagie: "Luftpiraten verwenden Halbmagie für Aufgaben, die mit der Instandhaltung, Reparatur und dem Bau kleinerer Luftschiffe (wie dem Drakkar) zu tun haben, für das Wissen über verschiedene Luftschifftypen und Schiffsmannschaften sowie für das Wissen über übliche Flugrouten.",
        TuF: {
            optionen: [
                {
                    f: 1,
                    t: 4,
                    talente: ["Gefahrensinn", "Hieb Ausweichen", "Luftsegeln", "Navigation", "Schildschlag", "Waffenloser Kampf", "Wildnisüberleben", "Windkissen", "Wispern", "Wurfwaffen"]
                },
                {
                    f: 5,
                    t: 8,
                    talente: ["Ablenken", "Eiserne Konstitution", "Erster Eindruck", "Führung", "Löwenherz", "Nachtreten", "Sprint", "Taktik", "Tigersprung", "Zweitwaffe"]
                },
                {
                    f: 9,
                    t: 12,
                    talente: ["Beeindrucken", "Bleibender Eindruck", "Letzte Rettung", "Löwenmut", "Lufttanz", "Schmerzen Widerstehen", "Starrsinn", "Sturmschild", "Unaufhaltsame Erholung", "Vitaler Schutz"]
                },
                {
                    f: 13,
                    t: 15,
                    talente: ["Adlerauge", "Ätherhaut", "Aurarüstung", "Herausforderung der Besten", "Kritischer Treffer", "Untergraben", "Waffenbruch", "Zweite Chance"]
                }
            ],
            1: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 0, s: 0},
                bew: 7,
                tot: 8,
                talente: ["Fadenweben [Himmelsweben]", "Feuerblut", "Kampfgebrüll", "Klettern", "Nahkampfwaffen"],
                free: [],
                karma: ""
            },
            2: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 0, s: 0},
                talente: ["Weitsprung"]
            },
            3: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 0, s: 0},
                karma: "1 Karmapunkt für Erholungsproben",
                talente: ["Standhaftigk8eit"]
            },
            4: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 0, s: 1},
                talente: ["Heilendes Feuer"]
            },
            5: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 0, s: 1},
                add: ["Überwältigende Kraft: Der Adept erleidet keine Überanstrengung mehr, wenn er die Kampfoption Aggressiver Angriff verwendet. Wenn eine andere Wirkung denselben Bonus gewährt, senkt der Adept die Mali stattdessen um 1."],
                karma: "D1 Karmapunkt für Schadensproben, die er mit Nahkampf- oder Wurfwaffen ablegt, deren Größe mindestens so hoch ist wie die einhändige Größenbegrenzung des Adepten",
                talente: ["Schlachtruf"]
            },
            6: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 2, m: 0, s: 1},
                talente: ["Stählerner Blick"]
            },
            7: {
                b: {ep: 1, mr: 0, ini: 0},
                v: {k: 2, m: 0, s: 1},
                talente: ["Schmetterschlag"]
            },
            8: {
                b: {ep: 1, mr: 0, ini: 0},
                v: {k: 3, m: 0, s: 1},
                talente: ["Schwungvoller Angriff"]
            },
            9: {
                b: {ep: 1, mr: 0, ini: 0},
                v: {k: 3, m: 0, s: 1},
                add: ["Stärke des Himmels: Der Adept führt ein achtstündiges Ritual durch, um aus der Kraft der Stürme zu schöpfen und seine Fähigkeiten zu verstärken. Das Ritual ist bei jedem Adepten unterschiedlich und für gewöhnlich von den Unterweisungen, die der Adept erhalten hat, und seiner persönlichen Philosophie geprägt. Einige Adepten erklimmen einen hohen Berggipfel während eines wütenden Sturms, werden vom Blitz getroffen und absorbieren dessen Kraft, während andere Adepten mächtige Sturmgeister oder Kreaturen mit einem ähnlichen elementaren Aspekt herausfordern. Das Ritual wird häufig als letzter Schritt durchgeführt, um ein Hüter zu werden, muss aber nicht zwingend zu dieser Zeit durchgeführt werden. Nach dem Ritual erleidet der Adept 1 Punkt Blutmagieschaden und addiert permanent +3 zu seinem Stärkewert."],
                karma: "Der Adept kann einen Karmapunkt für Proben ausgeben, um andere einzuschüchtern oder zu verängstigen.",
                talente: ["Brennende Kraft"]
            },
            10: {
                b: {ep: 1, mr: 0, ini: 1},
                v: {k: 3, m: 0, s: 2},
                talente: ["Unverzagte Tapferkeit"]
            },
            11: {
                b: {ep: 1, mr: 0, ini: 1},
                v: {k: 3, m: 1, s: 2},
                karma: "Der Adept kann einen Karmapunkt für Angriffsproben gegen einen Gegner ausgeben, der unter einer Furcht- oder Einschüchterungswirkung leidet. Es ist dabei nicht nötig, dass der Gegner unter einer Furcht- oder Einschüchterungswirkung leidet, die vom Adepten ausgeht.",
                talente: ["Tödlicher Schlag"]
            },
            12: {
                b: {ep: 2, mr: 0, ini: 1},
                v: {k: 4, m: 1, s: 2},
                talente: ["Zweiter Angriff"]
            },
            13: {
                b: {ep: 2, mr: 1, ini: 1},
                v: {k: 4, m: 1, s: 3},
                add: ["Sturmruf: Wenn der Adept die Kampfoption Aggressiver Angriff einsetzt, kann er einen Blitzhagel herbeirufen, um seine Feinde zu verletzen. Der Adept erleidet Schaden gleich seiner Wundschwelle sowie die damit verbundene Wunde (Rüstung schützt nicht gegen diesen Schaden), legt dann eine Himmelsweben-Probe ab und vergleicht das Ergebnis mit der Mystischen Verteidigung aller Ziele innerhalb einer Entfernung von 10 Schritt. Gelingt die Probe, erleidet das entsprechende Ziel Schaden mit einer Schadensstufe gleich der Stufe (nicht dem Rang) des Adepten in Himmelsweben plus seiner Wundschwelle. Rüstung schützt nicht gegen diesen Schaden.Der Adept muss zwischen einzelnen Anwendungen dieser Fähigkeit mindestens 10 Minuten lang ausruhen, und jede folgende Anwendung am selben Tag verursacht eine zusätzliche Wunde (die dritte Anwendung würde also 3 Wunden verursachen), was die Gefahr darstellt, diesen rohen elementaren Zorn zu kanalisieren. Einmal am Tag während seines Karmarituals kann der Adept eine Anzahl von Verbündeten gleich seinem Himmelsweben-Rang als Mitglieder seiner \"Mannschaft\" benennen. Diese Individuen werden bis zur Morgendämmerung des nächsten Tages nicht von dieser Fähigkeit beeinflusst.",],
                talente: ["Vom Donner Gerührt"]
            },
            14: {
                b: {ep: 2, mr: 1, ini: 2},
                v: {k: 5, m: 1, s: 3},
                talente: ["Üble Wunde"]
            },
            15: {
                b: {ep: 3, mr: 1, ini: 2},
                v: {k: 5, m: 2, s: 3},
                talente: ["Blut des Todesmeers"]
            }

        }
    },
    {
        url: "/wiki/Luftsegler",
        name: "Luftsegler",
        descr: "Luftsegler sind die säbelrasselnde Bruderschaft des Himmels. Sie lassen ihre Kameraden niemals im Stich, folgen dem Ideal der Zusammengehörigkeit und arbeiten lieber daran, die Zivilisation zu schützen und zu verbreiten, statt sich an ihr zu bereichern.",
        mainAttributes: ["cha", "ges", "wil"],
        karmaritual: "Zu Beginn seines Karmarituals sitzt der Luftsegler mehrere Minuten lang in stiller Meditation allein unter freiem Himmel und lässt sein Schiff im Geiste am Beginn einer langen Reise durch die Wolken segeln. Er stellt sich eine Luftreise vor, die er eines Tages zu unternehmen hofft, malt sich Szenen, Risiken und Gefahren dieser Reise aus und besinnt sich darauf, wie seine Ausbildung und seine Fähigkeiten dabei helfen werden, diese Reise sicher zu überstehen. Das Ritual ist vollendet, wenn die imaginäre Reise – eine halbe Stunde später – sicher endet.",
        kunsthandwerk: ["Runenschnitzen", "Segel Besticken"],
        halbmagie: "Ein Luftsegler kann Halbmagie für das Wissen über verschiedene Luftschiffdesigns, das Erkennen verschiedener Luftschifftypen, das Wissen über übliche Flugrouten und Besatzungen verwenden. Außerdem kann sie für Wartungsarbeiten, Reparaturen und die Konstruktion von Luftschiffen verwendet werden.\nAnmerkung: Bootsmänner in Barsaive sind in erster Linie T’skrang. Sie haben keine Verbindung zur Luft wie die Luftsegler, sondern zum Wasser, insbesondere zum strömenden Wasser des Flusssystems. Segler bewegen sich zwischen beiden Welten, überqueren die Meere und Flüsse, sind aber auf den Wind angewiesen, um ihre Reise zu beschleunigen. Luftsegler, Bootsmann und Segler werden hinsichtlich der Erfüllung von Anforderungen als dieselbe Disziplin behandelt. Luftweben, Flussweben und Meeresweben werden hinsichtlich der Erfüllung von Anforderungen als dasselbe Talent behandelt.",
        TuF: {
            optionen: [
                {
                    f: 1,
                    t: 4,
                    talente: ["Ablenken", "Akrobatische Verteidigung", "Erster Eindruck", "Feilschen", "Fremdsprachen", "Manövrieren", "Navigation", "Verspotten", "Weitsprung", "Wurfwaffen"]
                },
                {
                    f: 5,
                    t: 8,
                    talente: ["Eleganter Abgang", "Etikette", "Führung", "Gegenstand Verbergen", "Schlachtruf", "Starrsinn", "Überraschungsschlag", "Wispern", "Wortgeplänkel", "Zweitwaffe"]
                },
                {
                    f: 9,
                    t: 12,
                    talente: ["Adlerauge", "Astralsicht", "Beeindrucken", "Luftgleiten", "Reinigende Kälte", "Schadensverteilung", "Schmetterschlag", "Schwachstelle Erkennen", "Unaufhaltsame Erholung", "Verteidigungshaltung"]
                },
                {
                    f: 13,
                    t: 15,
                    talente: ["Entwaffnendes Lächeln", "Fließende Bewegung", "Herausforderung der Besten", "Kritischer Treffer", "Letzte Rettung", "Seelenschutz", "Untergraben", "Zweite Chance"]
                }
            ],
            1: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 0, s: 0},
                bew: 5,
                tot: 6,
                free: ["Luftsegeln"],
                karma: "einmal pro Runde 1 Karmapunkt für Aktionsproben, während er sich auf einem Luftschiff befindet.",
                talente: ["Fadenweben [Luftweben]", "Hieb Ausweichen", "Klettern", "Nahkampfwaffen", "Windkissen"]
            },
            2: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 0, s: 0},
                talente: ["Aufmerksamkeit"]
            },
            3: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 0, s: 0},
                karma: "1 Karmapunkt für Initiativeproben",
                talente: ["Empathische Wahrnehmung"]
            },
            4: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 0, s: 1},
                talente: ["Standhaftigkeit"]
            },
            5: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 0, s: 1},
                add: ["Zusammenarbeiten: Einmal pro Runde darf der Adept für 1 Punkt Überanstrengung einem Verbündeten als Einfache Aktion einen Bonus von +2 auf eine Probe für das Erreichen eines gemeinsamen Ziels geben. Der Spieler sollte beschreiben, wie der Adept seinem Verbündeten hilft."],
                karma: "1 Karmapunkt für Interaktionsproben",
                talente: ["Herzliches Lachen"]
            },
            6: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 2, m: 0, s: 1},
                talente: ["Lufttanz"]
            },
            7: {
                b: {ep: 1, mr: 0, ini: 0},
                v: {k: 2, m: 0, s: 1},
                talente: ["Andere Inspirieren"]
            },
            8: {
                b: {ep: 1, mr: 0, ini: 0},
                v: {k: 3, m: 0, s: 1},
                talente: ["Löwenherz"]
            },
            9: {
                b: {ep: 1, mr: 0, ini: 0},
                v: {k: 3, m: 0, s: 1},
                add: ["Angriffe Koordinieren: Jegliche Bedrängt-Mali, die vom Adepten verursacht werden, während er mit seinen Verbündeten zusammenarbeitet, werden um 1 erhöht. Dies gilt nicht für Bedrängt- Mali, die von Zaubern verursacht werden."],
                karma: "Der Adept kann einen Karmapunkt für Erholungsproben ausgeben.",
                talente: ["Bleibender Eindruck"]
            },
            10: {
                b: {ep: 1, mr: 0, ini: 1},
                v: {k: 3, m: 0, s: 2},
                talente: ["Gedankenkette"]
            },
            11: {
                b: {ep: 1, mr: 0, ini: 1},
                v: {k: 3, m: 1, s: 2},
                karma: "Der Adept kann einen Karmapunkt pro Runde für eine Probe ausgeben, während er sich neben einem Verbündeten befindet.",
                talente: ["Löwenmut"]
            },
            12: {
                b: {ep: 2, mr: 0, ini: 1},
                v: {k: 4, m: 1, s: 2},
                talente: ["Ansporn"]
            },

            13: {
                b: {ep: 2, mr: 1, ini: 1},
                v: {k: 4, m: 1, s: 3},
                add: ["Geschwindigkeit des Windes: Der Adept erleidet 4 Punkte Blutmagieschaden und legt eine Luftweben-(6)-Probe ab. Jeder Erfolg erhöht die Reisegeschwindigkeit seiner Gruppe um 10%. Diese Fähigkeit kann Fahrzeuge von maximal der Größe einer Galeere beeinflussen oder eine Gruppe von nicht mehr als 50 Personen, die zu Fuß gehen oder beritten sind. Im Kampf wird stattdessen die Bewegungsrate der betroffenen Fahrzeuge/Personen um 4 erhöht. Diese Fähigkeit wirkt für einen ganzen Tag, danach kann der Blutmagieschaden geheilt werden."],
                talente: ["Zweiter Angriff"]
            },
            14: {
                b: {ep: 2, mr: 1, ini: 2},
                v: {k: 5, m: 1, s: 3},
                talente: ["Lied der Schlachten"]
            },
            15: {
                b: {ep: 3, mr: 1, ini: 2},
                v: {k: 5, m: 2, s: 3},
                talente: ["Koordinierter Angriff"]
            }
        }
    },
    {
        url: "/wiki/Sch%C3%BCtze",
        name: "Schütze",
        descr: "Ein Schütze lernt die Kunst des Bogen- und Armbrustschießens sowie alle anderen Arten von Fernkampfangriffen. Diese Disziplin betont Präzision und Geschwindigkeit. Die meisten Schützen besitzen stark verbesserte Wahrnehmungskräfte und bemerken oft Dinge, die anderen entgehen.",
        mainAttributes: ['ges', "wah"],
        karmaritual: "Der Schütze verbringt die ersten Minuten seines Karmarituals damit, seinen Bogen zu ölen und zu bespannen. Dann meditiert er, mit dem Bogen vor sich und seinen Pfeilen neben sich auf dem Boden ausgebreitet. Während er meditiert, sucht er die Ruhe, die sich einstellt, kurz bevor der Pfeil von der Sehne gelassen wird. Dann schießt der Schütze drei Pfeile so auf ein Ziel, dass sie ein Dreieck von nicht mehr als einem Fuß Durchmesser formen, und einen vierten Pfeil in die Mitte des Dreiecks. Das Ritual ist vollendet, sobald der letzte Pfeil trifft. Der Schütze verbringt die ersten Minuten seines Karmarituals damit, seinen Bogen zu ölen und zu bespannen. Dann meditiert er, mit dem Bogen vor sich und seinen Pfeilen neben sich auf dem Boden ausgebreitet. Während er meditiert, sucht er die Ruhe, die sich einstellt, kurz bevor der Pfeil von der Sehne gelassen wird. Dann schießt der Schütze drei Pfeile so auf ein Ziel, dass sie ein Dreieck von nicht mehr als einem Fuß Durchmesser formen, und einen vierten Pfeil in die Mitte des Dreiecks. Das Ritual ist vollendet, sobald der letzte Pfeil trifft.",
        kunsthandwerk: ["Holzschnitzen", "Pfeile Befiedern"],
        halbmagie: "Schützen können Halbmagie einsetzen, um Fernkampfwaffen zu pflegen und verschiedene Arten von Fernkampfwaffen, Munition oder ihren Hersteller zu erkennen.",
        TuF: {
            optionen: [
                {
                    f: 1,
                    t: 4,
                    talente: ["Aufmerksamkeit", "Beeindrucken", "Erster Eindruck", "Heimlicher Schritt", "Klettern", "Navigation", "Spurenlesen", "Tieranalyse", "Wildnisüberleben", "Wurfwaffen"]
                },
                {
                    f: 5,
                    t: 8,
                    talente: ["Ablenken", "Bannmarkierung", "Beweisanalyse", "Eiserner Wille", "Etikette", "Fremdsprachen", "Gefahrensinn", "Konversation", "Starrsinn", "Tigersprung"]
                },
                {
                    f: 9,
                    t: 12,
                    talente: ["Astralsicht", "Ätherwaffe", "Bleibender Eindruck", "Chamäleon", "Holzhaut", "Kritischer Treffer", "Lebensblick", "Matrixsicht", "Untrüglicher Blick", "Verteidigungshaltung"]
                },
                {
                    f: 13,
                    t: 15,
                    talente: ["Gift", "Kreisender Spion", "Löwenherz", "Seelenschutz", "Tödlicher Schlag", "Unaufhaltsame Erholung", "Vitaler Schutz", "Zweite Chance"]
                },
            ],
            1: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 0, s: 0},
                bew: 5,
                tot: 6,
                free: ["Projektil Rufen"],
                karma: "1 Karmapunkt für Wahrnehmungsproben, die auf Sicht basieren.",
                talente: ["Blattschuss", "Fadenweben [Pfeilweben]", "Hieb Ausweichen", "Magische Markierung", "Projektilwaffen"]
            },

            2: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 0, s: 0},
                talente: ["Mystische Verfolgung"]
            },

            3: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 0, s: 0},
                karma: "1 Karmapunkt für Initiativeproben.",
                talente: ["Kampfsinn"]
            },
            4: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 1, s: 0},
                talente: ["Weitschuss"]
            },
            5: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 1, s: 0},
                add: ["Projektil Erschaffen: Einmal pro Runde darf der Adept als Standardaktion für 1 Punkt Überanstrengung eine Pfeilweben-(6)-Probe ablegen. Jeder Erfolg bei dieser Probe erschafft einen Pfeil, einen Bolzen oder eine Wurfwaffe. Alle so erschaffenen Gegenstände müssen vom selben Typ sein, und sie existieren für eine Anzahl von Minuten gleich dem Rang des Adepten in Pfeilweben; danach verschwinden sie. Sie gelten für die Zwecke von Talenten oder Zaubern, die dies erfordern, als normale Waffen bzw. Munition."],
                karma: "1 Karmapunkt für Schadensproben mit Fernkampfwaffen",
                talente: ["Schwachstelle Erkennen"]
            },
            6: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 2, m: 1, s: 0},
                talente: ["Gezielter Querschläger"]
            },
            7: {
                b: {ep: 0, mr: 1, ini: 1},
                v: {k: 2, m: 1, s: 0},
                talente: ["Brandpfeil"]
            },
            8: {
                b: {ep: 0, mr: 1, ini: 1},
                v: {k: 3, m: 1, s: 0},
                talente: ["Zweiter Schuss"]
            },
            9: {
                b: {ep: 0, mr: 1, ini: 1},
                v: {k: 3, m: 1, s: 0},
                add: ["Blutgebundener Bogen: Der Adept führt ein achtstündiges Ritual durch, um sich auf eine bestimmte Projektilwaffe einzustimmen, wodurch er 1 Punkt Blutmagieschaden erleidet. Das Ritual ist bei jedem Adepten unterschiedlich und für gewöhnlich von den Unterweisungen, die der Adept erhalten hat, und seiner persönlichen Philosophie geprägt. Es wird für gewöhnlich als letzter Schritt durchgeführt, um ein Hüter zu werden, muss aber nicht zwingend zu dieser Zeit durchgeführt werden. Nach dem Ritual erhält der Adept einen Bonus von +3 auf alle Angriffsproben mit der erwählten Waffe. Nur eine Waffe kann auf diese Art gleichzeitig gebunden werden, aber der Adept kann die Wirkung des Rituals jederzeit beenden, wodurch er den Blutmagieschaden heilen und eine andere Waffe binden kann."],
                karma: "Der Adept kann einen Karmapunkt für Erholungsproben ausgeben.",
                talente: ["Blind Schießen"]
            },
            10: {
                b: {ep: 0, mr: 1, ini: 1},
                v: {k: 3, m: 2, s: 0},
                talente: ["Astralangriff"]
            },
            11: {
                b: {ep: 0, mr: 1, ini: 1},
                v: {k: 3, m: 2, s: 1},
                karma: "Der Adept kann einmal pro Runde einen Karmapunkt für eine auf Wahrnehmung basierende Probe gegen einen Gegner ausgeben, dem er seit Beginn der vorigen Runde Schaden zugefügt hat.",
                talente: ["Adlerauge"]
            },
            12: {
                b: {ep: 0, mr: 1, ini: 2},
                v: {k: 4, m: 2, s: 1},
                talente: ["Zielerfassung"]
            },
            13: {
                b: {ep: 1, mr: 1, ini: 2},
                v: {k: 4, m: 3, s: 1},
                add: ["Perfekter Schuss: Der Adept verwendet übernatürliche Sinne und seine Verbindung zu seiner Waffe, um einen perfekten Schuss abzugeben. Einmal pro Runde kann er, bevor er einen Fernkampfangriff durchführt, maximal so viel Überanstrengung erleiden, wie seine Wahrnehmungsstufe beträgt. Gelingt der Angriff, addiert jeder Punkt Überanstrengung einen Bonus von +2 auf die Schadensprobe. Dies gilt zusätzlich zu sämtlichem auf herkömmlichem Weg erzielten Bonusschaden."],
                talente: ["Projektil Beeinflussen"]
            },
            14: {
                b: {ep: 1, mr: 2, ini: 2},
                v: {k: 5, m: 3, s: 1},
                talente: ["Schnappschuss"]
            },
            15: {
                b: {ep: 0, mr: 2, ini: 3},
                v: {k: 5, m: 3, s: 2},
                talente: ["Dauerfeuer"]
            }
        }
    },
    {
        url: "/wiki/Schwertmeister",
        name: "Schwertmeister",
        descr: "Schwertmeister sind Kämpfer, die den Wert einer gut geführten Waffe schätzen lernen und üben, um im Kampf Schnelligkeit, Reflexe und Stil zu zeigen. Für Schwertmeister ist Stil im Kampf häufig genauso wichtig wie die eigentliche Kampfkunst. Schwerter sind zwar die Waffen, die von dieser Disziplin am häufigsten eingesetzt werden, aber einige Schulen konzentrieren sich auf und lehren den Umgang mit anderen Waffen.",
        mainAttributes: ["ges", "cha"],
        karmaritual: "Der Schwertmeister ficht gegen imaginäre Gegner. Die ersten Duelle kämpft er als stille, einfache Übungen. Im Laufe der nächsten halben Stunde sorgt der Schwertmeister für Geräusche, vollführt akrobatische Bewegungen und fängt sogar verwegene Dialoge an. Das Ritual ist vollendet, wenn der letzte imaginäre Feind fällt.",
        kunsthandwerk: ["Schauspielerei", "Tanzen"],
        halbmagie: "Schwertmeister verwenden Halbmagie, um ihre Waffen zu pflegen, für das Wissen über die Geschichte legendärer Waffen und für das Identifizieren verschiedener Arten von Nahkampfwaffen. Außerdem können sie Halbmagie einsetzen, um die Kampftechniken eines anderen Schwertmeisters zu identifizieren, einschließlich der Frage, welche berühmten Schwertmeister seinen Stil vielleicht beeinflusst haben.",
        TuF: {
            optionen: [
                {
                    f: 1,
                    t: 4,
                    talente: ["Ablenken", "Akrobatische Verteidigung", "Beeindrucken", "Fremdsprachen", "Gefahrensinn", "Gewinnendes Lächeln", "Kampfsinn", "Standhaftigkeit", "Tigersprung", "Waffenloser Kampf"]
                },
                {
                    f: 5,
                    t: 8,
                    talente: ["Bleibender Eindruck", "Eleganter Abgang", "Etikette", "Kobrastoß", "Löwenherz", "Luftgleiten", "Nachtreten", "Schwachstelle Erkennen", "Sprint", "Wortgeplänkel"]
                },
                {
                    f: 9,
                    t: 12,
                    talente: ["Astralangriff", "Ätherwaffe", "Empathische Wahrnehmung", "Herausforderung der Besten", "Letzte Rettung", "Löwenmut", "Matrixsicht", "Schlagfertige Erwiderung", "Unaufhaltsame Erholung", "Untergraben"]
                },
                {
                    f: 13,
                    t: 15,
                    talente: ["Aurarüstung", "Bardenstimme", "Eisiger Schlag", "Schmerzen Widerstehen", "Seelenschutz", "Unverzagte Tapferkeit", "Vitaler Schutz", "Zweite Chance"]
                }
            ],
            1: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 0, s: 0},
                bew: 7,
                tot: 8,
                talente: ["Fadenweben [Waffenweben]", "Hieb Ausweichen", "Manövrieren", "Nahkampfwaffen", "Verspotten"],
                karma: "",
                free: []
            },
            2: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 0, s: 1},
                talente: ["Erster Eindruck"]
            },
            3: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 0, s: 1},
                karma: "1 Karmapunkt für Interaktionsproben",
                talente: ["Riposte"]
            },
            4: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 0, s: 1},
                talente: ["Herzliches Lachen"]
            },
            5: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 0, s: 1},
                add: ["Einschätzen: Der Adept erleidet 2 Punkte Überanstrengung, wendet eine Einfache Aktion auf und legt eine Waffenweben-Probe gegen die Mystische Verteidigung eines Gegners ab. Wenn die Probe gelingt, kann er eine spezielle Frage über eine der Eigenschaften dieses Gegners stellen. Diese Fähigkeit funktioniert wie das Talent Tieranalyse (S. 111), allerdings nur gegen Namensgeber, und es ist auch nur eine Frage pro Einsatz der Fähigkeit erlaubt."],
                karma: "1 Karmapunkt für Schadensproben mit einer Nahkampfwaffe",
                talente: ["Zweitwaffe"]
            },
            6: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 0, s: 2},
                talente: ["Entwaffnen"]
            },
            7: {
                b: {ep: 0, mr: 0, ini: 1},
                v: {k: 1, m: 0, s: 2},
                talente: ["Starrsinn"]
            },
            8: {
                b: {ep: 0, mr: 0, ini: 1},
                v: {k: 2, m: 0, s: 2},
                talente: ["Zweiter Angriff"]
            },
            9: {
                b: {ep: 0, mr: 0, ini: 1},
                v: {k: 2, m: 0, s: 2},
                add: ["Blutgebundene Waffen: Der Adept führt ein achtstündiges Ritual durch, um sich auf eine bestimmte Nahkampfwaffe einzustimmen, wodurch er 1 Punkt Blutmagieschaden erleidet. Das Ritual ist bei jedem Adepten unterschiedlich und für gewöhnlich von den Unterweisungen, die der Adept erhalten hat, und seiner persönlichen Philosophie geprägt. Es wird häufig als letzter Schritt durchgeführt, um ein Hüter zu werden, muss aber nicht zwingend zu dieser Zeit durchgeführt werden. Nach dem Ritual erhält die Waffe einen Bonus von +3 auf ihre Schadensstufe, wenn der Adept sie führt. Der Adept kann die Wirkung des Rituals jederzeit beenden, wodurch er den Blutmagieschaden heilen und eine andere Waffe binden kann. Er kann gleichzeitig bis zu zwei Waffen gebunden haben."],
                karma: "Der Adept kann einen Karmapunkt für Erholungsproben ausgeben.",
                talente: ["Kritischer Treffer"]
            },
            10: {
                b: {ep: 1, mr: 0, ini: 1},
                v: {k: 2, m: 0, s: 3},
                talente: ["Verteidigungshaltung"]
            },
            11: {
                b: {ep: 1, mr: 0, ini: 1},
                v: {k: 2, m: 1, s: 3},
                karma: "Der Adept kann einen Karmapunkt für eine Angriffsprobe gegen einen Gegner ausgeben, der aktuell durch Verspotten beeinflusst wird. Es ist dabei nicht notwendig, dass der Gegner von einem Verspotten des Adepten beeinflusst wird.",
                talente: ["Schwungvoller Angriff"]
            },
            12: {
                b: {ep: 1, mr: 0, ini: 2},
                v: {k: 3, m: 1, s: 3},
                talente: ["Fließende Bewegung"]
            },
            13: {
                b: {ep: 1, mr: 1, ini: 2},
                add: ["Tollkühner Wagemut: Der Adept kann seine Verbündeten zu Taten waghalsiger Vortrefflichkeit inspirieren, indem er sich Hals über Kopf in eine gefährliche Situation stürzt. Für 2 Punkte Überanstrengung erhalten alle, die an dieser unbedachten Aktion teilnehmen, für 3 Runden einen Bonus von +3 auf eine Aktionsprobe pro Runde (nach Wahl des Charakters)."],
                v: {k: 3, m: 1, s: 3},
                talente: ["Schneidende Worte"]
            },
            14: {
                b: {ep: 2, mr: 1, ini: 2},
                v: {k: 4, m: 1, s: 3},
                talente: ["Üble Wunde"]
            },
            15: {
                b: {ep: 2, mr: 1, ini: 3},
                v: {k: 4, m: 2, s: 3},
                talente: ["Mehrfacher Schlag"]
            }
        }
    },
    {
        url: "/wiki/Segler",
        name: "Segler",
        descr: "Segler sind die säbelrasselnde Bruderschaft des Wassers. Sie lassen ihre Kameraden niemals im Stich, folgen dem Ideal der Zusammengehörigkeit und arbeiten lieber daran, die Zivilisation zu schützen und zu verbreiten, statt sich an ihr zu bereichern.",
        mainAttributes: ["cha", "ges", "wil"],
        karmaritual: "Der Segler sitzt mehrere Minuten lang allein in stiller Meditation, vorzugsweise in der Nähe eines Flusses oder eines anderen Gewässers, und stellt sich vor, wie sein Flussschiff zu Beginn einer langen Reise durch die Strömung fährt. Der Adept stellt sich eine Reise vor, von der er hofft, sie eines Tages unternehmen zu können. Er stellt sich Szenen dieser Reise vor, einschließlich der Risiken und Gefahren und wie seine Ausbildung und seine Fähigkeiten dazu beitragen könnten, dass die Reise sicher verläuft. Das Ritual ist beendet, wenn die imaginierte Reise eine halbe Stunde später sicher endet.",
        kunsthandwerk: ["Runenschnitzen", "Segel Besticken"],
        halbmagie: "Der Segler verwendet Halbmagie für die Kenntnis von Schiffsdesigns, das Erkennen verschiedener Schiffstypen, allgemein bekannte Seehandelsrouten und zum Anheuern von Besatzungen. Er deckt damit auch die Wartung, die Reparatur und den Bau von Schiffen ab.\nAnmerkung: Bootsmänner in Barsaive sind in erster Linie T’skrang. Sie haben keine Verbindung zur Luft wie die Luftsegler, sondern zum Wasser, insbesondere zum strömenden Wasser des Flusssystems. Segler bewegen sich zwischen beiden Welten, überqueren die Meere und Flüsse, sind aber auf den Wind angewiesen, um ihre Reise zu beschleunigen. Luftsegler, Bootsmann und Segler werden hinsichtlich der Erfüllung von Anforderungen als dieselbe Disziplin behandelt. Luftweben, Flussweben und Meeresweben werden hinsichtlich der Erfüllung von Anforderungen als dasselbe Talent behandelt.",
        TuF: {
            optionen: [
                {
                    f: 1,
                    t: 4,
                    talente: ["Ablenken", "Akrobatische Verteidigung", "Erster Eindruck", "Feilschen", "Fremdsprachen", "Manövrieren", "Navigation", "Verspotten", "Weitsprung", "Wurfwaffen"]
                },
                {
                    f: 5,
                    t: 8,
                    talente: ["Eleganter Abgang", "Etikette", "Führung", "Gegenstand Verbergen", "Schlachtruf", "Starrsinn", "Überraschungsschlag", "Wispern", "Wortgeplänkel", "Zweitwaffe"]
                },
                {
                    f: 9,
                    t: 12,
                    talente: ["Adlerauge", "Astralsicht", "Beeindrucken", "Luftgleiten", "Reinigende Kälte", "Schadensverteilung", "Schmetterschlag", "Schwachstelle Erkennen", "Unaufhaltsame Erholung", "Verteidigungshaltung"]
                },
                {
                    f: 13,
                    t: 15,
                    talente: ["Entwaffnendes Lächeln", "Fließende Bewegung", "Herausforderung der Besten", "Kritischer Treffer", "Letzte Rettung", "Seelenschutz", "Untergraben", "Zweite Chance"]
                }
            ],
            1: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 0, s: 0},
                bew: 5,
                tot: 6,
                free: ["Segeln"],
                karma: "einmal pro Runde 1 Karmapunkt für Aktionsproben, während er sich auf einem Schiff befindet",
                talente: ["Fadenweben [Meeresweben]", "Hieb Ausweichen", "Klettern", "Nahkampfwaffen", "Schwimmen"]
            },
            2: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 0, s: 0},
                talente: ["Aufmerksamkeit"]
            },
            3: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 0, s: 0},
                karma: "1 Karmapunkt für Initiativeproben.",
                talente: ["Empathische Wahrnehmung"]
            },
            4: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 0, s: 1},
                talente: ["Standhaftigkeit"]
            },
            5: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 0, s: 1},
                add: ["Zusammenarbeiten: Einmal pro Runde darf der Adept für 1 Punkt Überanstrengung einem Verbündeten als Einfache Aktion einen Bonus von +2 auf eine Probe für das Erreichen eines gemeinsamen Ziels geben. Der Spieler sollte beschreiben, wie der Adept seinem Verbündeten hilft."],
                karma: "1 Karmapunkt für Interaktionsproben",
                talente: ["Herzliches Lachen"]
            },
            6: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 2, m: 0, s: 1},
                talente: ["Lufttanz"]
            },
            7: {
                b: {ep: 1, mr: 0, ini: 0},
                v: {k: 2, m: 0, s: 1},
                talente: ["Andere Inspirieren"]
            },
            8: {
                b: {ep: 1, mr: 0, ini: 0},
                v: {k: 3, m: 0, s: 1},
                talente: ["Löwenherz"]
            },
            9: {
                b: {ep: 1, mr: 0, ini: 0},
                v: {k: 3, m: 0, s: 1},
                add: ["Angriffe Koordinieren: Jegliche Bedrängt-Mali, die vom Adepten verursacht werden, während er mit seinen Verbündeten zusammenarbeitet, werden um 1 erhöht. Dies gilt nicht für Bedrängt- Mali, die von Zaubern verursacht werden."],
                karma: "Der Adept kann einen Karmapunkt für Erholungsproben ausgeben.",
                talente: ["Bleibender Eindruck"]
            },
            10: {
                b: {ep: 1, mr: 0, ini: 1},
                v: {k: 3, m: 0, s: 2},
                talente: ["Gedankenkette"]
            },
            11: {
                b: {ep: 1, mr: 0, ini: 1},
                v: {k: 3, m: 1, s: 2},
                karma: "Der Adept kann einen Karmapunkt pro Runde für eine Probe ausgeben, während er sich neben einem Verbündeten befindet.",
                talente: ["Löwenmut"]
            },
            12: {
                b: {ep: 2, mr: 0, ini: 1},
                v: {k: 4, m: 1, s: 2},
                talente: ["Ansporn"]
            },
            13: {
                b: {ep: 2, mr: 1, ini: 1},
                v: {k: 4, m: 1, s: 3},
                add: ["Geschwindigkeit des Windes: Der Adept erleidet 4 Punkte Blutmagieschaden und legt eine Meeresweben-(6)-Probe ab. Jeder Erfolg erhöht die Reisegeschwindigkeit seiner Gruppe um 10%. Diese Fähigkeit kann Fahrzeuge von maximal der Größe einer Galeere beeinflussen oder eine Gruppe von nicht mehr als 50 Personen, die zu Fuß gehen oder beritten sind. Im Kampf wird stattdessen die Bewegungsrate der betroffenen Fahrzeuge/Personen um 4 erhöht. Diese Fähigkeit wirkt für einen ganzen Tag, danach kann der Blutmagieschaden geheilt werden."],
                talente: ["Zweiter Angriff"]
            },
            14: {
                b: {ep: 2, mr: 1, ini: 2},
                v: {k: 5, m: 1, s: 3},
                talente: ["Lied der Schlachten"]
            },
            15: {
                b: {ep: 3, mr: 1, ini: 2},
                v: {k: 5, m: 2, s: 3},
                talente: ["Koordinierter Angriff"]
            }
        }
    },

    {
        url: "/wiki/Steppenreiter",
        name: "Steppenreiter",
        descr: "Steppenreiter sind wilde berittene Krieger. Sie trainieren mit ihren Reittieren und bilden ein enges empathisches Band zu ihnen aus. In der Regel respektiert ein Steppenreiter sein Reittier mehr als jeden Namensgeber, mit der seltenen Ausnahme anderer Steppenreiter. Diese Disziplin betont Bewegung und das Einfühlungsvermögen in das eigene Reittier.",
        mainAttributes: ["ges", "cha", "wah"],
        karmaritual: "Zu Beginn seines Karmarituals pflanzt der Steppenreiter eine Markierung in die Erde und reitet dann mehrere Minuten lang von ihr weg. Dann verbindet er sich die Augen und lenkt sein Reittier zurück in Richtung der Markierung. Wenn er sich der Markierung auf etwa 100 Schritt genähert hat, setzt er seine fast übersinnliche Verbindung zu seinem Reittier – und was immer er an anderen empathischen Talenten beherrscht – ein, um es zu einem Sturmangriff auf die Markierung zu bewegen. Immer noch mit verbundenen Augen schlägt er mit einer Waffe nach der Markierung. Dann entfernt er das Tuch um seine Augen, und das Ritual ist beendet.",
        kunsthandwerk: ["Flechten", "Körpermalerei"],
        halbmagie: "Steppenreiter können Halbmagie für das Wissen über verschiedene Arten von Reittieren einsetzen, die von den Namensgeberrassen verwendet werden, außerdem für die Pflege von Reitausrüstung, die Tierzucht und Erste Hilfe bei Tieren sowie für das Wissen über wichtige Kavallerieeinheiten Barsaives.Reittier: Steppenreiter beginnen das Spiel mit einem Reittier nach Maßgabe des Spielleiters (siehe Spielerhandbuch S. 257f für eine Auswahl). Das Reittier ist nur für das Reiten ausgebildet; der Steppenreiter muss es erst noch für den Kampf ausbilden (S. 235). Menschen, Elfen und Orks reiten gewöhnlich auf Pferden, aber viele Steppenreiter der Orkstämme reiten auch auf Tundrabestien. Trolle, Windlinge und Zwerge reiten nicht gern auf Pferden. Einige zwergische Steppenreiter reiten aufgrund ihrer geringeren Körpergröße auf Ponys, andere auf Troajins oder Huttawas. Wegen ihrer Körpergröße und ihres Gewichts reiten trollische Steppenreiter gelegentlich große Streitrösser, aber die meisten reiten auf Granlains, einer ungewöhnlich starken und robusten Pferdeart. Windlingssteppenreiter sind zu klein, um auf normalen Pferden zu reiten, und reiten deshalb häufig auf Kues – kleinen echsenähnlichen Reittieren – oder großen Vögeln, die Zoaks genannt werden.",
        TuF: {
            optionen: [
                {
                    f: 1,
                    t: 4,
                    talente: ["Erster Eindruck", "Fremdsprachen", "Herzliches Lachen", "Hieb Ausweichen", "Kampfgebrüll", "Konversation", "Schadensverteilung", "Sicherer Reitsitz", "Tieranalyse", "Tiere Bändigen"]
                },
                {
                    f: 5,
                    t: 8,
                    talente: ["Empathische Wahrnehmung", "Etikette", "Führung", "Furchterregender Sturmangriff", "Geisterreittier", "Löwenherz", "Projektilwaffen", "Reittierangriff", "Taktik", "Unempfindlichkeit (Tiergefährte)"]
                },
                {
                    f: 9,
                    t: 12,
                    talente: ["Beeindrucken", "Bleibender Eindruck", "Eiserne Konstitution", "Eiserner Wille", "Feuerblut", "Letzte Rettung", "Schlachtruf", "Schmetterschlag", "Starrsinn", "Verteidigungshaltung"]
                },
                {
                    f: 13,
                    t: 15,
                    talente: ["Ansporn", "Gedankenkette", "Herausforderung der Besten", "Löwenmut", "Schmerzen Widerstehen", "Üble Wunde", "Unverzagte Tapferkeit", "Zweite Chance"]
                }
            ],
            1: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 0, s: 0},
                bew: 7,
                tot: 8,
                talente: ["Fadenweben [Reiterweben]", "Kunstreiten", "Nahkampfwaffen", "Sturmangriff", "Tierfreundschaft"],
                karma: "",
                free: []
            },
            2: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 0, s: 0},
                talente: ["Abrichten"]
            },
            3: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 0, s: 0},
                karma: "1 Karmapunkt für Angriffsproben, die er bei einem Sturmangriff ablegt",
                talente: ["Tiergefährten Verbessern"]
            },
            4: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 0, s: 1},
                talente: ["Tiergefährten Rufen"]
            },
            5: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 0, s: 1},
                add: ["Eine Seele, Zwei Körper: Der Adept erhält einen Bonus von +2 auf eine beliebige, nicht kampfbezogene Probe, bei der es um seine Verbindung zu seinem bevorzugten Reittier geht. Tierfreundschaft, Abrichten und Schadensverteilung würden diesen Bonus zum Beispiel bekommen, Kunstreiten im Kampf aber nicht."],
                karma: "1 Karmapunkt für alle Schadensproben, die er ablegt, während er beritten ist.",
                talente: ["Reittier Panzern"]
            },
            6: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 2, m: 0, s: 1},
                talente: ["Schwenkangriff"]
            },
            7: {
                b: {ep: 1, mr: 0, ini: 0},
                v: {k: 2, m: 0, s: 1},
                talente: ["Abwehrkreis"]
            },
            8: {
                b: {ep: 1, mr: 0, ini: 0},
                v: {k: 3, m: 0, s: 1},
                talente: ["Doppelter Sturmangriff"]
            },
            9: {
                b: {ep: 1, mr: 0, ini: 0},
                v: {k: 3, m: 0, s: 1},
                add: ["Geteilte Stärke: Der Adept führt ein achtstündiges Ritual durch, um sein Band zu einem bestimmten Reittier zu verstärken. Das Ritual ist bei jedem Adepten unterschiedlich und für gewöhnlich von den Unterweisungen, die der Adept erhalten hat, und seiner persönlichen Philosophie geprägt. Es wird für gewöhnlich als letzter Schritt durchgeführt, um ein Hüter zu werden, muss aber nicht zwingend zu dieser Zeit durchgeführt werden. Nach dem Ritual erleidet der Adept 1 Punkt Blutmagieschaden, und sein Reittier erhält einen Bonus von +3 auf seine Stärkestufe. Der Adept kann mit dieser Fähigkeit nur ein Reittier gleichzeitig binden. Der Adept kann die Wirkung des Rituals jederzeit beenden, wodurch er den Blutmagieschaden heilen und ein anderes Reittier an sich binden kann."],
                karma: "Der Adept kann einen Karmapunkt für Erholungsproben ausgeben.",
                talente: ["Durchbohrender Angriff"]
            },
            10: {
                b: {ep: 1, mr: 0, ini: 1},
                v: {k: 3, m: 0, s: 2},
                talente: ["Unaufhaltsame Erholung"]
            },
            11: {
                b: {ep: 1, mr: 0, ini: 1},
                v: {k: 3, m: 1, s: 2},
                karma: "Der Adept kann einen Karmapunkt für Schadensproben seines Reittiers ausgeben.",
                talente: ["Schwungvoller Angriff"]
            },
            12: {
                b: {ep: 2, mr: 0, ini: 1},
                v: {k: 4, m: 1, s: 2},
                talente: ["Tiersprache"]
            },
            13: {
                b: {ep: 2, mr: 1, ini: 1},
                v: {k: 4, m: 1, s: 3},
                add: ["Eins im Geist: Der Adept kennt die Wahrheit über seinen Geist und den seines Reittiers; die beiden sind eins. Mit diesem Wissen kann der Adept die Realität austricksen und sein Reittier jederzeit zu sich holen. Er erleidet 4 Punkte Überanstrengung und legt eine Reiterweben-Probe gegen die Mystische Verteidigung seines Reittiers ab. Gelingt die Probe, erscheint das Reittier unter dem Adepten, als wäre es die ganze Zeit dort gewesen, und der Adept ist ordnungsgemäß beritten. Diese Fähigkeit funktioniert nicht, wenn es nicht genügend Platz für einen berittenen Charakter gibt."],
                talente: ["Kritischer Treffer"]
            },
            14: {
                b: {ep: 2, mr: 1, ini: 2},
                v: {k: 5, m: 1, s: 3},
                talente: ["Vom Donner Gerührt"]
            },
            15: {
                b: {ep: 3, mr: 1, ini: 2},
                v: {k: 5, m: 2, s: 3},
                talente: ["Mehrfacher Sturmangriff"]
            }
        }
    },
    {
        url: "/wiki/Tiermeister",
        name: "Tiermeister",
        descr: "Tiermeister sind Adepten, die mittels Magie Tiere und andere Kreaturen nachahmen und mit ihnen interagieren. Einige entwickeln diese Fähigkeiten, um herausragende Spurenleser und Überlebenskünstler zu werden, während andere magische Bande zu Tiergefährten ausbilden oder die Nutztiere abrichten und versorgen, die so wichtig für das alltägliche Leben in Barsaive sind.",
        mainAttributes: ["cha", "ges", "wil"],
        karmaritual: "Der Tiermeister geht einen großen Kreis um den Ort herum ab, an dem er zuletzt geschlafen hat. Dann setzt er sich in die Mitte des Kreises und ruft mit einem lautlosen, meditativen Ruf die Tiere der Gegend. Am Ende des halbstündigen Rituals nähert sich ihm ein typisches Tier der örtlichen Fauna, betritt aber nicht den Kreis. Der Tiermeister lädt das Tier mit einer Bewegung ein, den Kreis zu betreten, und vollendet so das Ritual. Das Tier verlässt dann den Kreis und verschwindet.",
        kunsthandwerk: ["Holzschnitzen", "Körpermalerei"],
        halbmagie: "Tiermeister können Halbmagie einsetzen, wenn sie mit Tieren arbeiten oder für sie sorgen, soweit dies nicht anderweitig durch ihre Talente abgedeckt wird. Beispiele dafür sind Tierzucht und Erste Hilfe. Tiermeister können Halbmagie einsetzen, um verschiedene Tiere, Tierspuren und anormales Verhalten von Tieren und Kreaturen zu erkennen.Anmerkung: Viele der Talente und Fähigkeiten des Tiermeisters beziehen sich auf Tiergefährten. Ein Tier kann als Tiergefährte gelten, wenn es gegenüber dem Tiermeister eine Loyale Haltung einnimmt. Siehe das Talent Tierfreundschaft auf S. 101 für weitere Informationen.",
        TuF: {
            optionen: [
                {
                    f: 1,
                    t: 4,
                    talente: ["Abrichten", "Akrobatische Verteidigung", "Gefahrensinn", "Heimlicher Schritt", "Klettern", "Spurenlesen", "Tieranalyse", "Tierfreundschaft", "Tiergefährten Verbessern", "Tierische Sinne"]
                },
                {
                    f: 5,
                    t: 8,
                    talente: ["Eiserne Konstitution", "Kobrastoß", "Löwenherz", "Mentale Tierkontrolle", "Nachtreten", "Schlachtruf", "Sprint", "Tiergefährten Rufen", "Tigersprung", "Unempfindlichkeit (Tiergefährte)"]
                },
                {
                    f: 9,
                    t: 12,
                    talente: ["Adlerauge", "Brennende Kraft", "Chamäleon", "Durchbohrender Angriff", "Gestalt des Bluthundes", "Letzte Rettung", "Reittier Panzern", "Schmerzen Widerstehen", "Stählerner Blick", "Verteidigungshaltung"]
                },
                {
                    f: 13,
                    t: 15,
                    talente: ["Aurarüstung", "Echolot", "Löwenmut", "Tiere Führen", "Tödlicher Schlag", "Vitaler Schutz", "Wie Eine Streunende Katze", "Zweite Chance"]
                }
            ],
            1: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 0, s: 0},
                bew: 7,
                tot: 8,
                talente: ["Fadenweben [Tierweben]", "Hieb Ausweichen", "Krallenhand", "Waffenloser Kampf", "Wildnisüberleben"],
                free: [],
                karma: ""
            },
            2: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 0, s: 0},
                talente: ["Aufmerksamkeit"]
            },
            3: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 0, s: 0},
                karma: "1 Karmapunkt für Erholungsproben",
                talente: ["Tiere Bändigen"]
            },
            4: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 0, s: 1},
                talente: ["Weitsprung"]
            },
            5: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 0, s: 1},
                add: ["Katzenhafte Anmut: Der Adept hat automatisch bei Proben Erfolg, um das Gleichgewicht zu halten (gilt nicht für Niederschlagsproben), und kann ohne weitere Kosten oder Probe mit einer Einfachen Aktion aufstehen."],
                karma: "1 Karmapunkt für Schadensproben im waffenlosen Kampf",
                talente: ["Schadensverteilung"]
            },
            6: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 2, m: 0, s: 1},
                talente: ["Tiersprache"]
            },
            7: {
                b: {ep: 1, mr: 0, ini: 0},
                v: {k: 2, m: 0, s: 1},
                talente: ["Schmetterschlag"]
            },
            8: {
                b: {ep: 1, mr: 0, ini: 0},
                v: {k: 3, m: 0, s: 1},
                talente: ["Blutige Krallen"]
            },
            9: {
                b: {ep: 1, mr: 0, ini: 0},
                v: {k: 3, m: 0, s: 1},
                add: ["Zähe Haut: Der Adept führt ein achtstündiges Ritual durch, um seine Haut mit tierischer Widerstandsfähigkeit zu durchtränken. Das Ritual ist bei jedem Adepten unterschiedlich und für gewöhnlich von den Unterweisungen, die der Adept erhalten hat, und seiner persönlichen Philosophie geprägt. Einige Adepten kommunizieren vielleicht mit einem Tiergefährten und nehmen Aspekte seines Wesens in sich auf, während andere vielleicht Blut und Haut einer wilden Kreatur verwenden, die sie vor Kurzem getötet haben. Das Ritual wird häufig als letzter Schritt durchgeführt, um ein Hüter zu werden, muss aber nicht zwingend zu dieser Zeit durchgeführt werden. Nach dem Ritual erleidet der Adept 1 Punkt Blutmagieschaden und addiert permanent +3 zu seinem Zähigkeitswert."],
                karma: "Der Adept kann einen Karmapunkt pro Runde für eine beliebige Probe (aber keine Kampfprobe) ausgeben, während er sich in der Wildnis befindet.",
                talente: ["Unaufhaltsame Erholung"]
            },
            10: {
                b: {ep: 1, mr: 0, ini: 1},
                v: {k: 3, m: 0, s: 2},
                talente: ["Kritischer Treffer"]
            },
            11: {
                b: {ep: 1, mr: 0, ini: 1},
                v: {k: 3, m: 1, s: 2},
                karma: "Der Adept kann einen Karmapunkt für eine Angriffsprobe gegen ein Ziel ausgeben, dem er zuvor Schaden zugefügt hat.",
                talente: ["Unverzagte Tapferkeit"]
            },
            12: {
                b: {ep: 2, mr: 0, ini: 1},
                v: {k: 4, m: 1, s: 2},
                talente: ["Schwungvoller Angriff"]
            },
            13: {
                b: {ep: 2, mr: 1, ini: 1},
                v: {k: 4, m: 1, s: 3},
                add: ["Tierische Kriegsgestalt: Für 5 Überanstrengungspunkte kann der Adept mit einer Einfachen Aktion die Merkmale anderer Kreaturen annehmen. Er erhält dafür 12 Punkte, die er nach eigenem Ermessen zwischen Initiative, Ränge in Krallenhand, Bewegungsrate und Physischer Rüstung aufteilen kann. Der Spieler sollte beschreiben, wie sich die Boni manifestieren und das Aussehen des Adepten beeinflussen. Die Punkte können für weitere 5 Überanstrengungspunkte umverteilt werden, allerdings maximal einmal pro Runde. Jede Anwendung dieser Fähigkeit wirkt für bis zu 10 Minuten. Der Adept kann sie pro Tag so oft einsetzen, wie sein Rang in Tierweben beträgt."],
                talente: ["Heulen"]
            },
            14: {
                b: {ep: 2, mr: 1, ini: 2},
                v: {k: 5, m: 1, s: 3},
                talente: ["Üble Wunde"]
            },
            15: {
                b: {ep: 3, mr: 1, ini: 2},
                v: {k: 5, m: 2, s: 3},
                talente: ["Gift"]
            }
        }
    },
    {
        url: "/wiki/Troubadour",
        name: "Troubadour",
        descr: "Troubadoure sind Unterhalter, Geschichtenerzähler, Schauspieler und Komponisten. Für das einfache Volk sind sie damit das, was einem Historiker oder Gelehrten am nächsten kommt.",
        mainAttributes: ["cha", "wah"],
        karmaritual: "Der Troubadour führt eine Ballade oder Parodie vor einem mindestens zweiköpfigen Publikum auf. Er kann jonglieren, Witze oder Lügengeschichten erzählen oder ernsthafte Legenden singen. Eine halbe Stunde nach Beginn vollendet der Troubadour seine Aufführung mit einer kurzen Geschichte und beendet diese mit dem Satz \"Und hier endet es, denn solcherart ist die Wahrheit der Dinge.",
        kunsthandwerk: ["Handwerk", "Körpermalerei", "Sticken"],
        halbmagie: "Troubadoure können Halbmagie-Proben für das Wissen um Legenden, Mythen und Folklore der Lande und Völker ihrer Heimatprovinz ablegen, außerdem für das Identifizieren von Instrumenten und darstellenden Künsten verschiedener Gegenden.",
        TuF: {
            optionen: [
                {
                    f: 1,
                    t: 4,
                    talente: ["Novize", "Beeindrucken", "Feilschen", "Fremdsprachen", "Gewinnendes Lächeln", "Hieb Ausweichen", "Konversation", "Lesen/Schreiben", "Nahkampfwaffen", "Verspotten", "Wurfwaffen"]
                },
                {
                    f: 5,
                    t: 9,
                    talente: ["Diplomatie", "Eleganter Abgang", "Führung", "Hypnotisieren", "Klingen Jonglieren", "Löwenherz", "Magische Maske", "Stimmen Imitieren", "Wispern", "Wortgeplänkel"]
                },
                {
                    f: 9,
                    t: 12,
                    talente: ["Akrobatische Verteidigung", "Büchergedächtnis", "Eidetisches Gedächtnis", "Eiserner Wille", "Entwaffnendes Lächeln", "Gedankenkette", "Kampfsinn", "Reinigende Kälte", "Untrüglicher Blick", "Zweitwaffe"]
                },
                {
                    f: 13,
                    t: 15,
                    talente: ["Dämonen Entgegentreten", "Gedanken Verbergen", "Geistessonde", "Kritischer Treffer", "Löwenmut", "Perfekte Konzentration", "Seelenschutz", "Zweite Chance"]
                }
            ],
            1: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 0, s: 0},
                bew: 5,
                tot: 6,
                free: ["Unterhalten [Der Adept hat Erfahrung mit Vorführungen vor einer Menge. Dieses Talent funktioniert wie die Fertigkeit Unterhalten, aber der Adept muss sich nicht auf eine Art des Unterhaltens spezialisieren. ]"],
                karma: "1 Karmapunkt für Interaktionsproben",
                talente: ["Artefaktgeschichte", "Erster Eindruck", "Fadenweben [Geschichtenweben]", "Gefühlsmelodie", "Herzliches Lachen"]
            },
            2: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 0, s: 1},
                talente: ["Etikette"]
            },
            3: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 0, s: 1},
                karma: "1 Karmapunkt für Proben, mit denen er Informationen beschafft oder sich an sie erinnert. Die Fähigkeit kann auch für Wissensproben eingesetzt werden.",
                talente: ["Empathische Wahrnehmung"]
            },
            4: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 1, s: 0},
                talente: ["Forschen"]
            },
            5: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 1, s: 0},
                add: ["Ein Letztes Wort: Wenn dem Adepten eine Probe gegen die Soziale Verteidigung eines Ziels misslingt, kann er für 2 Punkte Überanstrengung einen Karmawürfel zum ursprünglichen Probenergebnis hinzufügen. Ein Letztes Wort kann nur einmal pro misslungener Probe eingesetzt werden."],
                karma: "Einmal pro Runde darf der Adept 1 Karmapunkt für die Probe eines anderen Charakters ausgeben, indem er ihn ermutigt. Das Ziel muss den Troubadour dafür hören und/oder sehen können.",
                talente: ["Andere Inspirieren"]
            },
            6: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 1, s: 2},
                talente: ["Bleibender Eindruck"]
            },
            7: {
                b: {ep: 0, mr: 0, ini: 1},
                v: {k: 0, m: 1, s: 2},
                talente: ["Starrsinn"]
            },
            8: {
                b: {ep: 0, mr: 0, ini: 1},
                v: {k: 0, m: 1, s: 3},
                talente: ["Schuld Abwälzen"]
            },
            9: {
                b: {ep: 0, mr: 0, ini: 1},
                v: {k: 0, m: 2, s: 3},
                add: ["Unnatürlicher Charme: Der Adept führt ein achtstündiges Ritual durch, um seine Attraktivität auf mystische Weise zu verstärken. Das Ritual ist bei jedem Adepten unterschiedlich und für gewöhnlich von den Unterweisungen, die der Adept erhalten hat, und seiner persönlichen Philosophie geprägt. Der eine Adept schließt vielleicht einen Handel mit einem Geist ab und tauscht ein selbst komponiertes Lied gegen übernatürliche Anziehungskraft ein. Ein anderer nimmt vielleicht die Rolle eines legendären Meister-Troubadours an und tritt öffentlich als diese Person auf, wobei ein Rest der Essenz des Meisters verbleibt, wenn die Vorführung endet. Das Ritual wird häufig als letzter Schritt durchgeführt, um ein Hüter zu werden, muss aber nicht zwingend zu dieser Zeit durchgeführt werden. Nach dem Ritual erleidet der Adept 1 Punkt Blutmagieschaden und addiert permanent +3 zu seinem Charismawert."],
                karma: "Der Adept kann einen Karmapunkt für Erholungsproben ausgeben.",
                talente: ["Bardenstimme"]
            },
            10: {
                b: {ep:0, mr: 1, ini: 1},
                v: {k: 0, m: 2, s: 3},
                talente: ["Ansporn"]
            },
            11: {
                b: {ep: 0, mr: 1, ini: 1},
                v: {k: 1, m: 2, s: 3},
                karma: "Der Adept kann einen Karmapunkt pro Runde für jede Probe ausgeben, während er sich neben einem Verbündeten befindet.",
                talente: ["Untergraben"]
            },
            12: {
                b: {ep: 0, mr: 1, ini: 1},
                v: {k: 1, m: 2, s: 4},
                talente: ["Schlagfertige Erwiderung"]
            },
            13: {
                b: {ep: 1, mr: 1, ini: 1},
                v: {k: 1, m: 3, s: 4},
                add: ["Dacapo: Der Adept kann 1 Punkt Überanstrengung erleiden, um eine beliebige auf Charisma basierende Fähigkeit zweimal in einer Runde einzusetzen und dabei ihre Wirkungen zu addieren. Wenn die Fähigkeit eine Standardaktion braucht, kostet sie 2 Punkte Überanstrengung. Dies gilt zusätzlich zu sonstiger Überanstrengung, die die Fähigkeit eventuell standardmäßig kostet.",],
                talente: ["Schneidende Worte"]
            },
            14: {
                b: {ep: 1, mr: 2, ini: 1},
                v: {k: 1, m: 3, s: 5},
                talente: ["Lied der Ablenkung"]
            },
            15: {
                b: {ep: 1, mr: 2, ini: 3},
                v: {k: 2, m: 3, s: 5},
                talente: ["Lied der Schlachten"]
            }
        }
    },


    {
        url: "/wiki/Waffenschmied",
        name: "Waffenschmied",
        descr: "Ein Waffenschmied arbeitet hart daran, einen eisernen Willen und ein scharfes Auge zu bekommen. Zusätzlich zu ihrer Rolle als Handwerker, die gewöhnliche Waffen, Rüstungen und andere Waren herstellen, helfen Waffenschmiede dabei, legendäre Waffen zu identifizieren und zu erschaffen. Fast alle Siedlungen halten ihren Waffenschmied in hohen Ehren.",
        mainAttributes: ["cha", "wah", "wil"],
        karmaritual: "Der Waffenschmied erhitzt einen dünnen Streifen Metall in einem heißen Feuer oder einer Esse. Im Laufe der nächsten halben Stunde formt er das Metall zu einer Klinge, Pfeilspitze oder Speerspitze, aber statt einen brauchbaren Gegenstand zu schmieden, kühlt er das Metall absichtlich zu früh ab und macht es spröde. Dann zerbricht er das fehlerhafte Stück Metallarbeit und beendet damit das Ritual.",
        kunsthandwerk: ["Holzschnitzen", "Runenschnitzen"],
        halbmagie: "Waffenschmiede können Halbmagie einsetzen, um Waffen und Rüstungen zu pflegen und verschiedene Arten von Waffen und Rüstungen (oder ihre Hersteller) zu erkennen.",
        TuF: {
            optionen: [
                {
                    f: 1,
                    t: 4,
                    talente: ["Aufmerksamkeit", "Erster Eindruck", "Fallen Entschärfen", "Feilschen", "Feuerblut", "Fremdsprachen", "Gefahrensinn", "Hieb Ausweichen", "Lesen/Schreiben", "Schildschlag"]
                },
                {
                    f: 5,
                    t: 8,
                    talente: ["Astralangriff", "Astralsicht", "Beweisanalyse", "Löwenmut", "Matrixsicht", "Schwungvoller Angriff", "Stählerner Blick", "Unaufhaltsame Erholung", "Unverzagte Tapferkeit", "Untrüglicher Blick"]
                },
                {
                    f: 9,
                    t: 12,
                    talente: ["Diplomatie", "Eiserne Konstitution", "Erdhaut", "Etikette", "Führung", "Heilendes Feuer", "Herzliches Lachen", "Kampfgebrüll", "Projektilwaffen", "Starrsinn"]
                },
                {
                    f: 13,
                    t: 15,
                    talente: ["Ätherwaffe", "Brennende Kraft", "Hammerschlag", "Schmerzen Widerstehen", "Tödlicher Schlag", "Vitaler Schutz", "Waffenbruch", "Zweite Chance"]
                }
            ],
            1: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 0, s: 0},
                bew: 5,
                tot: 6,
                free: ["Handwerk"],
                karma: "1 Karmapunkt für jede Probe, um einen Gegenstand herzustellen oder zu reparieren.",
                talente: ["Artefaktgeschichte", "Eiserner Wille", "Fadenweben [Fadenschmieden]", "Nahkampfwaffen", "Waffe Schmieden"]
            },
            2: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 1, s: 0},
                talente: ["Konversation"]
            },
            3: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 1, s: 0},
                karma: "1 Karmapunkt für Erholungsproben",
                talente: ["Fluch Unterdrücken"]
            },
            4: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 1, s: 0},
                talente: ["Standhaftigkeit"]
            },
            5: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 1, s: 0},
                add: ["Reisende Schmiede: Für 2 Punkte Überanstrengung kann der Adept auf Reisen mithilfe von Magie eine improvisierte Schmiede erschaffen, vorausgesetzt, er hat mindestens die benötigten Dinge, wie etwa ein Feuer für das Bearbeiten von Metall. Die Reisende Schmiede hält 1 Tag lang und verleiht einen Malus von -3 auf alle Proben, die mit ihr abgelegt werden. Nur der Waffenschmied, der sie erschaffen hat, darf die Schmiede für Proben verwenden."],
                karma: "1 Karmapunkt für Schadensproben mit einer Waffe, die er selbst hergestellt hat.",
                talente: ["Rüstung Schmieden"]
            },
            6: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 1, m: 2, s: 0},
                talente: ["Ätherhaut"]
            },
            7: {
                b: {ep: 0, mr: 1, ini: 0},
                v: {k: 1, m: 2, s: 0},
                talente: ["Schwachstelle Erkennen"]
            },
            8: {
                b: {ep: 0, mr: 1, ini: 0},
                v: {k: 1, m: 3, s: 0},
                talente: ["Löwenherz"]
            },
            9: {
                b: {ep: 0, mr: 1, ini: 0},
                v: {k: 1, m: 3, s: 0},
                add: ["Blutgebundene Esse: Der Adept kann Waffen oder Rüstungen verstärken, die er hergestellt hat. Dazu berührt er den Gegenstand und durchtränkt ihn mit der Macht seines Blutes, indem er 1 Punkt Blutmagieschaden erleidet. Waffen erhalten einen Bonus von +3 auf ihre Schadensstufe, Rüstungen erhalten einen Bonus von jeweils +2 auf ihre Physische und Mystische Rüstung. Jeder, der einen solchen Gegenstand verwendet, profitiert von dem jeweiligen Bonus. Der Adept kann insgesamt eine Anzahl von Gegenständen von maximal seinem Rang in Fadenschmieden verstärken, und er kann nur einen Gegenstand pro Runde verstärken. Der Bonus hält an, bis der Adept das Band löst (dann kann er den entsprechenden Blutmagieschaden heilen) oder stirbt."],
                karma: "Der Adept kann einen Karmapunkt pro Runde für jede Probe eines Verbündeten ausgeben, der sich neben ihm befindet.",
                talente: ["Perfekte Konzentration"]
            },
            10: {
                b: {ep: 1, mr: 1, ini: 0},
                v: {k: 2, m: 3, s: 0},
                talente: ["Magie Neutralisieren"]
            },
            11: {
                b: {ep: 1, mr: 1, ini: 0},
                v: {k: 2, m: 3, s: 1},
                karma: "Der Adept kann einen Karmapunkt für jede Probe ausgeben, um den Auswirkungen eines Zaubers oder einer Dämonenkraft zu widerstehen.",
                talente: ["Lebendige Waffe"]
            },
            12: {
                b: {ep: 1, mr: 2, ini: 0},
                v: {k: 2, m: 4, s: 1},
                talente: ["Fleisch Schmieden"]
            },
            13: {
                b: {ep: 1, mr: 2, ini: 1},
                v: {k: 3, m: 4, s: 1},
                add: ["Mystische Erdung: Bevor die jeweilige Probe abgelegt wird, kann der Adept 1 Punkt Überanstrengung erleiden, um einen Zauber oder eine Dämonenkraft, der oder die gegen einen Verbündeten gerichtet ist, auf sich selbst zu lenken. Der Verbündete muss sich innerhalb von [[[#Fadenweben|Fadenschmieden]] x 2] Schritt befinden. Der Adept widersteht der Wirkung, als sei er das ursprüngliche Ziel gewesen, einschließlich der Fähigkeit, defensive oder reagierende Fähigkeiten einzusetzen. Pro Tag kann er dies maximal so oft tun, wie sein Rang in Fadenschmieden beträgt. Diese Fähigkeit kann nicht für das Ablenken von Flächenwirkungen verwendet werden."],
                talente: ["Aurarüstung"]
            },
            14: {
                b: {ep: 2, mr: 2, ini: 1},
                v: {k: 3, m: 5, s: 1},
                talente: ["Seelenschutz"]
            },
            15: {
                b: {ep: 2, mr: 3, ini: 1},
                v: {k: 3, m: 5, s: 2},
                talente: ["Dämonen Entgegentreten"]
            }
        }
    },

    {
        url: "/wiki/Elementarist",
        name: "Elementarist",
        descr: "Ein Elementarist ist ein Zauberer, der sich darauf konzentriert, die fünf magischen Elemente (Erde, Feuer, Holz, Luft und Wasser) zu verstehen und Macht über sie zu erlangen.",
        mainAttributes: ["wah", "wil"],
        karmaritual: "Der Elementarist zeichnet ein großes Dreieck auf den Boden. Dann setzt er sich in das Dreieck, bringt Wasser in einem Topf zum Kochen und singt dabei zum Feuer, um dessen Hitze zu stärken. Dann löscht er das Feuer, fügt dem Wasser Erde hinzu und verwandelt es so in heißen Schlamm. Nachdem er den Schlamm ein paar Minuten lang hat abkühlen lassen, bedeckt der Elementarist sein Gesicht damit wie mit einer Kriegsbemalung, singt dann zum Wind und ruft eine leichte Brise hervor. Während der Wind den Schlamm trocknet, bricht ein Großteil davon weg, wird weggeweht und hinterlässt eine Reihe von komplizierten, wirbelnden Mustern. Damit ist das Karmaritual vollendet.",
        kunsthandwerk: ["Bildhauerei", "Roben Besticken"],
        halbmagie: "Elementaristen verwenden Halbmagie für Wissen über die Natur und die Elemente, über den Einsatz von Elementarmagie und über andere magische Rituale. Der Elementarist darf eine auf Wahrnehmung basierende Halbmagie-Probe ablegen, um die Anwesenheit von Elementargeistern innerhalb eines Radius von 30 Schritt zu entdecken. Der Entdeckungsmindestwurf hierfür ist die Mystische Verteidigung des Geistes. Wenn die Probe gelingt, spürt der Elementarist die Anwesenheit des Elementargeistes und kann Zauber oder Talente wie etwa Elementarsprachen oder Elementarbann einsetzen, um mit dem Geist zu kommunizieren und zu interagieren. Der Spielleiter kann diese Halbmagie-Probe jederzeit anstelle des Elementaristen ablegen, da dieser Sinn immer aktiv ist.",
        TuF: {
            optionen: [
                {
                    f: 1,
                    t: 4,
                    talente: ["Arkanes Gefasel", "Artefaktgeschichte", "Astralsicht", "Hieb Ausweichen", "Klettern", "Standardmatrix", "Spurenlesen", "Wildnisüberleben", "Windkissen", "Wispern"]
                },
                {
                    f: 5,
                    t: 8,
                    talente: ["Eiserner Wille", "Erweiterte Matrix", "Feuerblut", "Hartnäckiges Gewebe", "Luftgleiten", "Magie Neutralisieren", "Navigation", "Reinigende Kälte", "Sicherer Pfad", "Verbannen"]
                },
                {
                    f: 9,
                    t: 12,
                    talente: ["Ätherhaut", "Beschwörungskreis", "Beweisanalyse", "Eiserne Konstitution", "Fluch Unterdrücken", "Gepanzerte Matrix", "Perfekte Konzentration", "Pflanzensprache", "Wettstreit des Willens", "Zauberreichweite"]
                },
                {
                    f: 13,
                    t: 15,
                    talente: ["Brennende Kraft", "Letzte Rettung", "Schockbehandlung", "Struktur Beeinflussen", "Summenmatrix", "Unverzagte Tapferkeit", "Zauberstruktur", "Zweite Chance"]
                }
            ],
            1: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 0, s: 0},
                bew: 3,
                tot: 4,
                free: ["Standardmatrix", "Standardmatrix"],
                talente: ["Aufmerksamkeit", "Fadenweben [Elementarismus]", "Holzhaut", "Spruchzauberei", "Struktur Verstehen"],
                karma: ""
            },
            2: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 1, s: 0},
                talente: ["Heilendes Feuer"]
            },
            3: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 1, s: 0},
                karma: "1 Karmapunkt für Erholungsproben ausgeben.",
                talente: ["Elementarsprachen"]
            },
            4: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 1, s: 0},
                talente: ["Elementarbann"]
            },
            5: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 1, s: 0},
                add: ["Eines der kostenlosen Standardmatrix-Talente des Adepten wird zu einer Erweiterten Matrix aufgewertet.",
                    "Feuer und Eis: Für 1 Punkt Überanstrengung kann der Adept als Standardaktion mit einer erfolgreichen Elementarismus-Probe gegen die Mystische Verteidigung des Ziels oder gegen 6 (den höheren der beiden Werte) eines der folgenden Dinge tun:\nEr kann eine kleine Flamme zwischen Daumen und Zeigefinger erscheinen lassen. Diese Flamme hält nur 1 Runde lang, ist aber heiß genug, um eine Fackel zu entzünden. Wenn sie im Kampf eingesetzt wird, verursacht sie Feuerschaden der Stufe 4 (gegen den Physische Rüstung schützt).\nEr kann Wasser durch Berührung mit seinen mittleren drei Fingern gefrieren lassen. Der Adept kann mit jeder Anwendung dieser Fähigkeit bis zu 1 Quart Wasser gefrieren lassen. Wenn er diese Fähigkeit im Kampf einsetzt, verursacht sie Kälteschaden der Stufe 4 (gegen den Physische Rüstung schützt)."],
                talente: ["Beschwören [Elementargeister]"],
                karma: "1 Karmapunkt ausgeben, um einen zusätzlichen Verbündeten mit einem Zauber zu belegen, den er wirkt. "
            },
            6: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 2, s: 0},
                talente: ["Willensstärke"]
            },
            7: {
                b: {ep: 1, mr: 0, ini: 0},
                v: {k: 0, m: 2, s: 0},
                talente: ["Erdhaut"]
            },
            8: {
                b: {ep: 1, mr: 0, ini: 0},
                v: {k: 0, m: 3, s: 0},
                talente: ["Faden Halten"]
            },
            9: {
                b: {ep: 1, mr: 0, ini: 0},
                v: {k: 0, m: 3, s: 0},
                add: ["Erde und Wind: Der Adept erleidet 2 Punkte Überanstrengung und legt eine Elementarismus-(6)-Probe ab. Gelingt die Probe, kann er eines der folgenden Dinge tun:\nEinen Erdkreis mit einem Radius von 2 Schritt pro Erfolg erschaffen, der allen Verbündeten innerhalb des Kreises einen Bonus von +3 auf ihre Mystische Verteidigung gewährt. Der Kreis kann nicht bewegt werden, aber der Elementarist muss nicht in ihm bleiben, um die Wirkung aufrechtzuerhalten Die Wirkung hält maximal 24 Stunden an, kann aber jederzeit vom Adepten aufgehoben werden.\nEine Luftströmung erschaffen, die durch eine Kuppel mit einem Radius von 2 Schritt pro Erfolg zirkuliert. Die Luft stammt von der Ebene der Luft und ist, obwohl kalt, sauber und frisch. Sie verweht sofort sämtliche schädlichen Dämpfe; werden diese durch eine magische Wirkung hervorgerufen, gilt das Ergebnis der Elementarismus-Probe als Ergebnis einer Probe auf Magie Neutralisieren. Der beeinflusste Bereich kann nicht bewegt werden, aber der Elementarist muss nicht in ihm bleiben, um die Wirkung aufrechtzuerhalten. Die Wirkung hält maximal 24 Stunden an, kann aber jederzeit vom Adepten aufgehoben werden."],
                talente: ["Donnernde Entschlossenheit"],
                karma: "1 Karmapunkt ausgeben, wenn er einen Gegenstand entwirft oder anfertigt. "
            },
            10: {
                b: {ep: 1, mr: 1, ini: 0},
                v: {k: 2, m: 3, s: 0},
                talente: ["Beherrschung der Elemente"]
            },
            11: {
                b: {ep: 1, mr: 1, ini: 0},
                v: {k: 2, m: 3, s: 1},
                karma: "1 Karmapunkt ausgeben, um einen Bonus aus einem Zauber, den er auf einen Verbündeten wirkt, um +2 zu erhöhen.",
                talente: ["Rankenrüstung"]
            },
            12: {
                b: {ep: 2, mr: 1, ini: 0},
                v: {k: 2, m: 4, s: 1},
                talente: ["Zweiter Zauber"]
            },
            13: {
                b: {ep: 2, mr: 1, ini: 1},
                v: {k: 3, m: 4, s: 1},
                add: ["Elementargestalt: Für 5 Überanstrengungspunkte greift der Adept mit einer Einfachen Aktion auf seine Verbindung mit den Elementen zu und verschmilzt seinen Geist mit einem der Elemente. Während diese Fähigkeit aktiv ist, erhält er einen Bonus von +3 auf Spruchzauberei- (einschließlich Zweiter Zauber), Fadenweben- und Wirkungsproben bei allen Zaubern des gewählten Elements, und jeder Zauber wird mit einem kostenlosen zusätzlichen Faden gewebt (für den keine Fadenweben-Probe erforderlich ist, der aber immer noch gegen das normale Fadenmaximum zählt). Der Adept kann keine Zauber des Elements wirken, das seinem gewählten überlegen ist (Luft kann nicht Erde verwenden, Erde nicht Holz, Feuer nicht Wasser, Wasser nicht Luft und Holz nicht Feuer). Der Adept kann diese Gestalt pro Tag für insgesamt maximal [Rang in Elementarismus] Runden nutzen. Die Überanstrengungskosten werden nur für das Aktivieren gezahlt, nicht für jede folgende Runde in derselben Gestalt. Falls der Adept die Gestalt ändern will oder die Fähigkeit auch nur für eine Runde deaktiviert, muss er die Überanstrengungskosten erneut zahlen."],
                talente: ["Elementarwandeln"]
            },
            14: {
                b: {ep: 2, mr: 2, ini: 1},
                v: {k: 3, m: 5, s: 1},
                talente: ["Steinhaut"]
            },
            15: {
                b: {ep: 3, mr: 2, ini: 1},
                v: {k: 3, m: 5, s: 2},
                talente: ["Gespleißtes Gewebe"]
            }
        }
    },

    {
        url: "/wiki/Geisterbeschw%C3%B6rer",
        name: "Geisterbeschwörer",
        descr: "Geisterbeschwörer sind Zauberer, die sich auf die Magie der Anderwelten spezialisieren. Ihre Interessen richten sich auf andere Ebenen und die Geister und Kreaturen, die diese Ebenen bevölkern. Die meisten Leute finden, dass Geisterbeschwörer auf eine unheimliche Art ein wenig verrückt sind, weshalb die wenigsten Anhänger dieser Disziplin Beliebtheitswettbewerbe gewinnen dürften.",
        mainAttributes: ["cha", "wah", "wil"],
        karmaritual: "Der Geisterbeschwörer trinkt mit einem Dienergeist oder einer anderen Kreatur der Anderwelten Tee und unterhält sich mit ihr über das Leben jenseits dieser Welt. Das Ritual endet nach einer halben Stunde, wenn der Geisterbeschwörer den letzten Tropfen aus seiner letzten Tasse Tee trinkt.",
        kunsthandwerk: ["Knochenschnitzen", "Roben Besticken"],
        halbmagie: "Geisterbeschwörer verwenden Halbmagie, um Anwendungen von Geisterbeschwörermagie, verschiedene Arten von Untoten und Geistern sowie magische – besonders blutmagische – Rituale zu erkennen. Geisterbeschwörer können Halbmagie auch verwenden, um die Wirkungen verschiedener Blutamulette zu verstehen, da diese mit Geisterbeschwörung in Verbindung stehen. Ein Geisterbeschwörer darf eine auf Wahrnehmung basierende Halbmagie-Probe ablegen, um die Anwesenheit von Geistern innerhalb eines Radius von 30 Schritt zu entdecken. Der Entdeckungsmindestwurf hierfür ist die Mystische Verteidigung des Geistes. Wenn die Probe gelingt, spürt der Geisterbeschwörer die Anwesenheit des Geistes und kann Zauber oder Talente wie etwa Geistersprache oder Geisterbann einsetzen, um mit dem Geist zu kommunizieren und zu interagieren. Der Spielleiter kann diese Halbmagie-Probe jederzeit anstelle des Geisterbeschwörers ablegen, da dieser Sinn immer aktiv ist.",
        TuF: {
            optionen: [
                {
                    f: 1,
                    t: 4,
                    talente: ["Arkanes Gefasel", "Aufmerksamkeit", "Fluch Unterdrücken", "Fremdsprachen", "Heimlicher Schritt", "Hieb Ausweichen", "Lesen/Schreiben", "Magie Neutralisieren", "Nachtflieger Befehligen", "Standardmatrix"]
                },
                {
                    f: 5,
                    t: 8,
                    talente: ["Astrale Interferenz", "Erweiterte Matrix", "Forschen", "Geisterreittier", "Hartnäckiges Gewebe", "Lebensblick", "Löwenherz", "Schadensverteilung", "Stählerner Blick", "Verbannen"]
                },
                {
                    f: 9,
                    t: 12,
                    talente: ["Artefaktgeschichte", "Astraltasche", "Beschwörungskreis", "Beweisanalyse", "Gedanken Verbergen", "Gepanzerte Matrix", "Perfekte Konzentration", "Seelenschutz", "Wettstreit des Willens", "Zauberreichweite"]
                },
                {
                    f: 13,
                    t: 15,
                    talente: ["Dämonen Entgegentreten", "Löwenmut", "Mentale Tierkontrolle", "Schmerzen Widerstehen", "Struktur Beeinflussen", "Summenmatrix", "Zauberstruktur", "Zweite Chance"]
                }
            ],
            1: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 0, s: 0},
                bew: 3,
                tot: 4,
                free: ["Standardmatrix", "Standardmatrix"],
                talente: ["Astralsicht", "Fadenweben [Geisterbeschwörung]", "Spruchzauberei", "Struktur Verstehen", "Verängstigen"],
                karma: ""
            },
            2: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 1, s: 0},
                talente: ["Eiserner Wille"]
            },
            3: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 1, s: 0},
                karma: "einmal pro Runde 1 Karmapunkt für eine beliebige Probe gegen einen Dämon, ein Dämonenkonstrukt oder ein untotes Ziel",
                talente: ["Geistersprache"]
            },
            4: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 1, s: 1},
                talente: ["Geisterbann"]
            },
            5: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 1, s: 1},
                add: ["Eines der kostenlosen Standardmatrix-Talente des Adepten wird zu einer [Erweiterten Matrix aufgewertet.",
                    "Blutbeschwörung: Der Adept kann Blutmagieschaden in Höhe der Stärkestufe eines beschworenen Geistes erleiden, um einen zusätzlichen Erfolg bei einer Beschwören-Probe zu erhalten. Dieser Schaden kann erst einen vollen Tag, nachdem der Geist den Dienst des Beschwörers verlassen hat, geheilt werden."],
                karma: "1 Karmapunkt, um den Malus, den ein Ziel durch einen Zauber erhält, den der Adept wirkt, um 2 zu erhöhen.",
                talente: ["Beschwören [Verbündetengeister]"]
            },
            6: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 2, s: 1},
                talente: ["Willensstärke"]
            },
            7: {
                b: {ep: 0, mr: 1, ini: 0},
                v: {k: 0, m: 2, s: 1},
                talente: ["Kreisender Spion"]
            },
            8: {
                b: {ep: 0, mr: 1, ini: 0},
                v: {k: 0, m: 3, s: 1},
                talente: ["Faden Halten"]
            },
            9: {
                b: {ep: 0, mr: 1, ini: 0},
                v: {k: 0, m: 3, s: 1},
                add: ["Jenseitige Willenskraft: Der Adept führt ein achtstündiges Ritual durch, um seinen Willen mithilfe von astralen Einflüssen zu stählen. Das Ritual ist bei jedem Adepten unterschiedlich und für gewöhnlich von den Unterweisungen, die der Adept erhalten hat, und seiner persönlichen Philosophie geprägt. Einige Geisterbeschwörer beschwören vielleicht Verbündetengeister und tauschen ein Stück ihrer Wahren Struktur, während andere ihre Psyche direkt dem Astralraum aussetzen. Das Ritual wird häufig als letzter Schritt durchgeführt, um ein Hüter zu werden, muss aber nicht zwingend zu dieser Zeit durchgeführt werden. Nach dem Ritual erleidet der Adept 1 Punkt Blutmagieschaden und addiert permanent +3 zu seinem Willenskraftwert."],
                karma: "Der Adept kann einen Karmapunkt für Erholungsproben ausgeben.",
                talente: ["Matrixsicht"]
            },
            10: {
                b: {ep: 1, mr: 1, ini: 0},
                v: {k: 0, m: 3, s: 2},
                talente: ["Blutiger Einblick"]
            },
            11: {
                b: {ep: 1, mr: 1, ini: 0},
                v: {k: 1, m: 3, s: 2},
                karma: "Der Adept kann beim Wirken eines Zaubers mit dem Schlüsselwort Herbeirufung oder Bindung einen Karmapunkt ausgeben, um einen Bonus oder eine Wirkungsstufe aus dem Zauber um +2 zu erhöhen oder einen Malus aus dem Zauber um -2 zu senken.",
                talente: ["Geistwandeln"]
            },
            12: {
                b: {ep: 1, mr: 2, ini: 0},
                v: {k: 1, m: 4, s: 2},
                talente: ["Zweiter Zauber"]
            },
            13: {
                b: {ep: 1, mr: 2, ini: 1},
                v: {k: 1, m: 4, s: 3},
                add: ["Astralgesicht: Für 4 Überanstrengungspunkte kann der Adept mit einer Einfachen Aktion seine Gesichtszüge verändern, um ein besseres Gespür für den Astralraum zu erhalten. Die veränderte Erscheinung ist glatter, die Haut häufig silbern oder schwarz. Die Augen enthalten Flecken unirdischen Lichts, und die Zähne sind stumpf und matt, bis auf eine kleine Rune auf jedem Zahn. Der Adept erhält einen Bonus von +5 auf Spruchzauberei- (einschließlich Zweiter Zauber) und Wirkungsproben, solange diese Fähigkeit wirkt. Der Adept kann diese Fähigkeit pro Tag für insgesamt maximal [Rang in Geisterbeschwörung] Runden nutzen. Die Überanstrengungskosten werden nur für das Aktivieren der Fähigkeit gezahlt, nicht für jede Runde. Falls der Adept auch nur für eine Runde aufhört, die Fähigkeit zu nutzen, muss er die Überanstrengungskosten erneut zahlen."],
                talente: ["Astrale Domäne"]
            },
            14: {
                b: {ep: 2, mr: 2, ini: 1},
                v: {k: 1, m: 5, s: 3},
                talente: ["Seele des Jenseits"]
            },
            15: {
                b: {ep: 2, mr: 3, ini: 1},
                v: {k: 2, m: 5, s: 3},
                talente: ["Gespleißtes Gewebe"]

            }
        }
    },

    {
        url: "/wiki/Illusionist",
        name: "Illusionist",
        descr: "Illusionisten wirken Zauber, die die Wahrnehmung täuschen. Es gibt aber auch Illusionistenzauber, die reale Auswirkungen haben. Reine Illusionen, das lernten Illusionisten früh, wurden von den Leuten schnell durchschaut, was ihre Magie weniger effektiv machte. Deshalb besteht ihre Magie heutzutage aus einer Mischung aus echter Magie, Illusionen, Täuschung und Taschenspielertricks.",
        mainAttributes: ["cha", "wah", "wil"],
        karmaritual: "Ein Illusionist verwendet nicht jedes Mal dasselbe Ritual, es muss allerdings jedes Mal bestimmte Elemente enthalten: auffällige Zauber, Tricks oder flotte Sprüche sowie einen Assistenten. Abgesehen davon erfindet der Illusionist sein Karmaritual spontan. Der Illusionist muss während dieser Zeit sein Bestes geben, um seinen Assistenten davon zu überzeugen, dass das Ritual sehr ernst ist und einem präzisen Schema folgen muss.",
        kunsthandwerk: ["Roben Besticken", "Schauspielern"],
        halbmagie: "Illusionisten legen Halbmagie-Proben ab, um verschiedene Arten des Magiegebrauchs und spezielle Anwendungen von Illusionsmagie zu erkennen. Außerdem können sie mit Halbmagie versuchen, die „Wahrheit“ einer bestimmten Situation wahrzunehmen.",
        TuF: {
            optionen: [
                {
                    f: 1,
                    t: 4,
                    talente: ["Arkanes Gefasel", "Astralsicht", "Aufmerksamkeit", "Fremdsprachen", "Gewinnendes Lächeln", "Heimlicher Schritt", "Standardmatrix", "Stimmen Imitieren", "Totstellen", "Verspotten"]
                },
                {
                    f: 5,
                    t: 8,
                    talente: ["Eiserner Wille", "Erweiterte Matrix", "Flinke Hand", "Gegenstand Verbergen", "Hartnäckiges Gewebe", "Magie  Neutralisieren", "Schuld Abwälzen", "Starrsinn", "Verängstigen", "Wortgeplänkel"]
                },
                {
                    f: 9,
                    t: 12,
                    talente: ["Astraltasche", "Bleibender Eindruck", "Eleganter Abgang", "Empathische Wahrnehmung", "Etikette", "Gedanken Verbergen", "Gedankenkette", "Gepanzerte Matrix", "Untergraben", "Zauberreichweite"]
                },
                {
                    f: 13,
                    t: 15,
                    talente: ["Bardenstimme", "Schlagfertige Erwiderung", "Seelenschutz", "Struktur Beeinflussen", "Summenmatrix", "Unmögliches Versteck", "Zauberstruktur", "Zweite Chance"]
                }
            ],
            1: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 0, s: 0},
                bew: 3,
                tot: 4,
                free: ["Standardmatrix", "Standardmatrix"],
                talente: ["Erster Eindruck", "Fadenweben [Illusionismus]", "Illusionsverstärkung", "Spruchzauberei", "Struktur Verstehen"],
                karma: ""
            },
            2: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 1, s: 0},
                talente: ["Untrüglicher Blick"]
            },
            3: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 1, s: 0},
                karma: "1 Karmapunkt für Interaktionsproben",
                talente: ["Konversation"]
            },
            4: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 1, s: 1},
                talente: ["Magische Maske"]
            },
            5: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 1, s: 1},
                add: ["Eines der kostenlosen Standardmatrix-Talente des Adepten wird zu einer Erweiterten Matrix aufgewertet.",
                    "Glamour: Für 2 Punkte Überanstrengung erschafft der Adept mit einer Standardaktion eine offensichtliche Illusion (für die keine Durchschauen-Probe erforderlich ist), um Zuschauer zu unterhalten und zu erfreuen. Er legt eine Illusionismus-Probe gegen die höchste Soziale Verteidigung unter den Zuschauern ab. Wenn die Probe gelingt, erhält er für eine Anzahl von Stunden gleich der Anzahl der erzielten Erfolge einen Bonus von +2 auf Proben, um Eindruck zu machen."
                ],
                karma: "1 Karmapunkt, um einen Bonus von +2 auf die Wirkungsstufe eines Zaubers zu addieren. Der Bonus hält für die gesamte Wirkungsdauer des Zaubers an, selbst wenn der Zauber mehrere Wirkungsproben hat.",
                talente: ["Machtmaskierung"]
            },
            6: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 2, s: 1},
                talente: ["Willensstärke"]
            },
            7: {
                b: {ep: 0, mr: 0, ini: 1},
                v: {k: 0, m: 2, s: 1},
                talente: ["Hypnotisieren"]
            },
            8: {
                b: {ep: 0, mr: 0, ini: 1},
                v: {k: 0, m: 3, s: 1},
                talente: ["Faden Halten"]
            },
            9: {
                b: {ep: 0, mr: 0, ini: 1},
                v: {k: 0, m: 3, s: 1},
                add: ["Zauber Verbergen: Für 2 Punkte Überanstrengung kann der Adept mit einer Freien Aktion die Illusion erschaffen, dass er keinen Zauber wirkt. Der Illusionismus-Rang des Adepten gilt als Zauberkreis, um den Durchschauen-Mindestwurf zu bestimmen. Jeder Charakter, der normalerweise das Spruchzaubern beobachten könnte, kann eine Durchschauen-Probe ablegen. Der Zauber darf keine schädigende Wirkung haben."],
                karma: "Der Adept kann einen Karmapunkt für Erholungsproben ausgeben.",
                talente: ["Entwaffnendes Lächeln"]
            },
            10: {
                b: {ep: 0, mr: 1, ini: 1},
                v: {k: 0, m: 3, s: 2},
                talente: ["Gedächtnis Durchdringen"]
            },
            11: {
                b: {ep: 0, mr: 1, ini: 1},
                v: {k: 1, m: 3, s: 2},
                talente: ["Wahrheit Durch Lügen"],
                karma: "Der Adept kann einen Karmapunkt ausgeben, um einen zusätzlichen Gegner mit einem Zauber aufs Korn zu nehmen, den er gerade wirkt. Der duplizierte Zauber ist eine Illusion (egal, ob der ursprüngliche Zauber auch eine ist oder nicht), was entsprechende Anzweifeln- beziehungsweise Durchschauen- Proben erlaubt."
            },
            12: {
                b: {ep: 0, mr: 1, ini: 2},
                v: {k: 1, m: 4, s: 2},
                talente: ["Zweiter Zauber"]
            },
            13: {
                b: {ep: 1, mr: 1, ini: 2},
                v: {k: 1, m: 4, s: 3},
                add: ["Realität Manipulieren: Für 1 Punkt Überanstrengung kann der Adept das Schlüsselwort Illusion zu jedem Zauber hinzufügen, den er wirkt. Diese Zauber können dann wie gewohnt angezweifelt werden oder Opfer von Durchschauen-Proben sein. Das Ziel des Zaubers muss eventuell eine Durchschauen-Probe ablegen, um festzustellen, dass der Zauber eine Illusion ist. Ein illusionärer Fliegender Teppich beispielsweise erlaubt es dem Ziel nicht, zu fliegen, aber das Ziel merkt das eventuell nicht sofort. Für 3 Überanstrengungspunkte kann der Adept das Schlüsselwort Illusion von jedem Zauber entfernen, den er wirkt, wodurch dessen Wirkung real wird. Die Auswirkungen dieser Disziplinfähigkeit sind mächtig und unvorhersagbar und haben vielleicht nicht jedes Mal genau dieselbe Wirkung. Das genaue Ergebnis unterliegt der Maßgabe des Spielleiters, sollte aber auch die Vorstellungen des Spielers bezüglich des gewünschten Ergebnisses berücksichtigen; der Charakter ist schließlich ein Meister-Illusionist und sollte eine Vorstellung davon haben, was er tut. Nachdem diese Fähigkeit auf einen Zauber angewandt wurde, um das Schlüsselwort Illusion von ihm zu entfernen, muss der nächste gewirkte Zauber eine Illusion sein, selbst wenn das erfordert, dass der Adept diese Fähigkeit einsetzt, um den Zauber zu einer Illusion zu machen."],
                talente: ["Fesselnde Visionen"]
            },
            14: {
                b: {ep: 1, mr: 2, ini: 2},
                v: {k: 1, m: 5, s: 3},
                talente: ["Geistessonde"]
            },
            15: {
                b: {ep: 1, mr: 2, ini: 3},
                v: {k: 2, m: 5, s: 3},
                talente: ["Gespleißtes Gewebe"]
            }
        }
    },

    {
        url: "/wiki/Magier",
        name: "Magier",
        descr: "Magier sind Zauberer, die sich auf die theoretischen Aspekte der Magie konzentrieren. Die Anhänger anderer Zaubererdisziplinen verunglimpfen Magier manchmal als Bücherwürmer, aber es ist doch interessant, dass nur wenige den Mut haben, dies einem Magier ins Gesicht zu sagen.",
        mainAttributes: ["cha", "wah", "wil"],
        karmaritual: "Der Magier zeichnet einen Kreis von mindestens zwei Schritt Durchmesser und zeichnet in diesen Kreis ein Dreieck. Nachdem er alle Korrekturen bezüglich der Genauigkeit der Zeichnung vorgenommen hat, zeichnet er einen weiteren Kreis in das Dreieck, dann ein Dreieck in diesen Kreis und so weiter. Schon bald ist der Magier gezwungen, Formen zu zeichnen, die kleiner sind, als sie von Hand mit einem Stift gezeichnet werden können. Er muss die Kraft der Magie nutzen, um weiterzuzeichnen, selbst wenn die Zeichnungen zu klein werden, als dass sie noch mit dem bloßen Auge zu erkennen wären. Die halbstündige Sequenz endet mit einem Dreieck, und das Ritual ist vollendet, sobald das letzte Dreieck gezeichnet wurde.",
        kunsthandwerk: ["Manuskript-Illumination", "Roben Besticken"],
        halbmagie: "Magier können Halbmagie einsetzen, um verschiedene Arten von Magie zu erkennen, spezielle Anwendungen von Magiermagie zu identifizieren sowie für Wissen über magische Rituale.",
        TuF: {

            optionen: [
                {
                    f: 1,
                    t: 4,
                    talente: ["Arkanes Gefasel", "Artefaktgeschichte", "Aufmerksamkeit", "Büchergedächtnis", "Etikette", "Fremdsprachen", "Konversation", "Lesen/Schreiben", "Standardmatrix", "Tieranalyse"]
                },
                {
                    f: 5,
                    t: 8,
                    talente: ["Beweisanalyse", "Diplomatie", "Erweiterte Matrix", "Hieb Ausweichen", "Hypnotisieren", "Lebensblick", "Machtmaskierung", "Mystische Verfolgung", "Starrsinn", "Untrüglicher Blick"]
                },
                {
                    f: 9,
                    t: 12,
                    talente: ["Astraltasche", "Eleganter Abgang", "Empathische Wahrnehmung", "Erster Eindruck", "Gedanken Verbergen", "Gedankenkette", "Gepanzerte Matrix", "Matrixsicht", "Perfekte Konzentration", "Zauberreichweite"]
                },
                {
                    f: 13,
                    t: 15,
                    talente: ["Astrale Domäne", "Geistessonde", "Seelenschutz", "Struktur Beeinflussen", "Summenmatrix", "Untergraben", "Zauberstruktur", "Zweite Chance"]
                }
            ],
            1: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 0, s: 0},
                bew: 3,
                tot: 4,
                free: ["Standardmatrix", "Standardmatrix"],
                talente: ["Fadenweben [Magie]", "Forschen", "Magie Neutralisieren", "Spruchzauberei", "Struktur Verstehen"],
                karma: ""
            },
            2: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 1, s: 0},
                talente: ["Astralsicht"]
            },
            3: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 1, s: 0},
                karma: "Darf 1 Karmapunkt für Proben ausgeben, um sich an Informationen zu erinnern (einschließlich Wissensproben).",
                talente: ["Hartnäckiges Gewebe"]
            },
            4: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 1, s: 1},
                talente: ["Eiserner Wille"]
            },
            5: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 1, s: 1},
                add: ["Eines der kostenlosen Standardmatrix-Talente des Adepten wird zu einer Erweiterten Matrix aufgewertet.",
                    "Buchzauberer: Für 1 Punkt Überanstrengung erhält der Adept einen Bonus von +5 für eine Fadenweben-Probe, um auf die Schnelle neu abzustimmen, wenn er sich den Zauber in seinem Grimoire anschaut."],
                karma: "1 Karmapunkt, um die Reichweite eines Zaubers von Selbst auf Berührung zu ändern.",
                talente: ["Astrale Interferenz"]
            },
            6: {
                b: {ep: 0, mr: 0, ini: 0},
                v: {k: 0, m: 2, s: 1},
                talente: ["Willensstärke"]
            },
            7: {
                b: {ep: 0, mr: 1, ini: 0},
                v: {k: 0, m: 2, s: 1},
                talente: ["Faden Halten"]
            },
            8: {
                b: {ep: 0, mr: 1, ini: 0},
                v: {k: 0, m: 3, s: 1},
                talente: ["Fluch Unterdrücken"]
            },
            9: {
                b: {ep: 0, mr: 1, ini: 0},
                v: {k: 0, m: 3, s: 1},
                add: ["Matrixspaltung: Der Adept kann jede seiner Zaubermatrizen einen zusätzlichen Zauber aufnehmen lassen, indem er pro solcher Matrix 2 Punkte Blutmagieschaden erleidet. Jede Matrix kann nur einmal gespalten werden, und nur die persönlichen Matrizen des Adepten (keine Matrixgegenstände) können gespalten werden. Der Gesamtkreis der Zauber, die eine Matrix enthält, darf nicht den Rang dieser Zaubermatrix übersteigen. Gepanzerte und Erweiterte Matrizen halten keine Fäden mehr, wenn sie gespalten werden. Diese Fähigkeit hält für 24 Stunden an. Danach kann der Blutmagieschaden geheilt werden."],
                karma: "Der Adept kann einen Karmapunkt für Erholungsproben ausgeben.",
                talente: ["Eidetisches Gedächtnis"]
            },
            10: {
                b: {ep: 0, mr: 1, ini: 1},
                v: {k: 0, m: 3, s: 2},
                talente: ["Glyphe der Entflechtung"]
            },
            11: {
                b: {ep: 0, mr: 1, ini: 1},
                v: {k: 1, m: 3, s: 2},
                talente: ["Glyphe des Schutzes"],
                karma: "Der Adept kann einen Karmapunkt ausgeben, um augenblicklich einen zusätzlichen Faden auf einem Zauber zu erlauben, den er wirkt. Die normalen Anforderungen an zusätzliche Fäden gelten weiterhin und der zusätzliche Faden muss regulär gewoben werden."
            },
            12: {
                b: {ep: 0, mr: 2, ini: 1},
                v: {k: 1, m: 3, s: 2},
                talente: ["Zweiter Zauber"]
            },
            13: {
                b: {ep: 1, mr: 2, ini: 1},
                v: {k: 1, m: 3, s: 3},
                add: ["Mystisches Dreieck: Der Adept kann 4 Punkte Blutmagieschaden erleiden und mit einer Standardaktion ein mystisches Dreieck um sich herum erschaffen, dessen Seiten jeweils nicht mehr als 2 Schritt lang sein dürfen. Während sich der Adept in dem Dreieck befindet, erhält er einen Bonus von jeweils +5 auf Spruchzauberei- und Fadenweben-Proben, einschließlich Proben mit Talenten, die diese Talente ersetzen (z. B. Zweiter Zauber), und Glyphen-Proben. Das Dreieck bleibt wirksam, bis der Adept es verlässt. Dann verschwindet es, und der Blutmagieschaden kann normal geheilt werden."],
                talente: ["Glyphe der Neuabstimmung"]
            },
            14: {
                b: {ep: 1, mr: 2, ini: 2},
                v: {k: 1, m: 5, s: 3},
                talente: ["Glyphe der Spiegelung"]
            },
            15: {
                b: {ep: 1, mr: 3, ini: 2},
                v: {k: 2, m: 5, s: 3},
                talente: ["Gespleißtes Gewebe"]
            }
        }
    }
];

export default data_disziplinen;